
import { memo, useState, useEffect, useCallback, useMemo, useRef, forwardRef, useImperativeHandle, createRef } from 'react';
import { BzButton, BzInputText, BzToggleButton, BzChip, BzDotsLoader, BzMasterAgGrid, BzDropdown, BzTabs, BzTab, BzToolTip, } from '../../../components';
import { Row, Col, Dropdown, Container, Button } from 'react-bootstrap';
import { TabsScripsList } from '../../Search';
import { WATCHLIST_GRID_INDEX, TL_INDEX, SUPPORT_RESISTANCE_VIEW, ORDER_ENTRY_BUTTON_TOGGLE, APP_INFO_PARAMS, FACILITY_STR, GLOBAL_SEARCH_MIN_LENGTH, ORDER_ENTRY_TYPES, LAYOUT_TYPE, MARKET_SEGMENT_ID, GRID_ROW_SELECTION_TYPE, MAX_SEARCH_SCRIP_PER_PAGE, SCRIP_INSTRUMENTS, EXCHANGE_NAME_API, ORDER_PRODUCT_TYPES, MSG_MASTER, ORDER_ENTRY_BUY_SELL_TEXT, CAUTIONARY_TRANSACTION_TYPE, TRADING_NOT_ALLOWED_MSG_BASKET } from "../../../utils/global_variables";
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce, useWFHMessages } from '../../../hooks';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import SupportResistance from '../../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../../AllExchangesMarketDepth';
import { getBannedScripStatus, getBannedScripsList, getBannedScripsListFailure, getExchangeWiseScripInfo, getMarketStatus, getOrderMarginInfo, orderMarginInfoSuccess, setShowSideTrayPlaceOrder } from '../../../redux/actions/orders';
import { calculateSupportRestistanceValues, convertEditCart, convertNumberWithCommasForCurrency, deepClone, getApiExchangeNameFromMktSegId, getAppInfoData, getDynamicParamsForToFixed, getMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, MULTISCRIP_ORDER_CART_GRID_REF, setMultiScripOrderCartGridRef, makeGridRowSelected } from "../../../utils/global_functions";
import { useLocation } from 'react-router';
import BrokerageModalMultiLeg from './BrokerageModalMultiLeg';
import { toastConfig } from '../../../redux/actions/toast';
import { convertToOrderCart, getOrderCartOptionChain, getOrderCartScrps, getOrderDataBackupVertical, getOrderMarketPriceList, saveCartSuccess, storeGridData, updateOrderCartRowData, updateOrdercartMargin, updatePrevOrderData } from '../../../redux/actions/orderCart';
import { getOptionChainData } from '../../../apis';
import { getSearchDataAsPerSearchIndexes } from '../../../controllers/globalSearch';
import SurvMeasureModal from './SurvMeasureModal';
import { getSearchAllScrips } from '../../../redux/actions/globalSearch';
import uniqBy from 'lodash/uniqBy';
import MarketDepthGrid from '../../MarketOverview/MarketDepthGrid';
import BannedScripModal from './BannedScripModal';
import { isEqual } from 'lodash';
import { updateBasketReco } from '../../../redux/actions/recommendation';
import { _checkSegmetAllowed } from '../../../controllers';
import PreTradeFailedScripsModal from './PreTradeFailedScripsModal';

const objDropdownOptions = {
    // productType: ["DELIVERY", "INTRADAY", "CARRYFORWARD", "MTF", "PTST"],
    productType: [
        { isDefault: true, prodDesc: "Delivery", isSelected: true },
        { isDefault: false, prodDesc: "Margin" },
    ],
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    orderType: ["RL", "RL-MKT", "SL", "SL-MKT"],
    validityNSE: ["DAY", "IOC"],
    validityBSE: ["EOSESS", "EOTODY", "IOC"],
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    arrType: ["BUY", "SELL"],
    exchange: ["NSE", "BSE"],//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order
    heading: ["BUY/SELL", "SYMBOL", "EXCHANGE", "PROD TYPE", "ORDER TYPE", "QTY", "PRICE", "VALIDITY", "AMO", "SL TRIGGER", "SL LIMIT", ""]
};



const Basket = forwardRef(({ layoutType,
    activeButtonToggleIndex, setAddToggle,
    arrGlobalScripts, activeTabKey, multiScripOrderActiveTabKey, setBIsSaveCartBack,
    // eslint-disable-next-line no-empty-function
    arrMarginInfo, setBIsShowCreateCart = () => { }, bIsPlaceOrderBtnDisabled, setBIsPlaceOrderBtnDisabled = () => { }, bIsConfirmBack, bIsSaveCartBack, orderInfo, ...props }, ref) => {
    const dispatch = useDispatch();
    const activeWatchList = useSelector(state => state.watchList.activeWatchList);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -Start
    const [strCartName, setStrCartName] = useState('');
    const [strCartId, setStrCartId] = useState('');
    const objSavedCartDetails = useSelector(state => state?.orderCart?.objCartForGoBack);
    const arrOrderCartOptionChainData = useSelector(state => state?.orderCart?.arrCartFromOptionChain);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024  -End
    const objSelectedCartRowData = useSelector(state => state?.orderCart?.objSelectedCartRowData);   //srikanth
    const arrData = useSelector(state => state?.orderCart?.arrOrderEntryGridData);
    const [rowData, setRowData] = useState([]);
    const [isFlag, setIsFlag] = useState(0);
    const [isShowMarketDepth, setIsShowMarketDepth] = useState(false);
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('MarketDepth');
    const [supportResistance, setSupportResistance] = useState({});
    const [strSearchInputText, setStrSearchInputText] = useState("");
    const [orderBookSearchModal, setOrderBookSearchModal] = useState(false);
    const [globalScripDetails, setGlobalScripDetails] = useState([]);
    const [scripAddedInfo, setScripAddedInfo] = useState([]);
    const [bDisableSaveBtn, setBDisableSaveBtn] = useState(false);
    const bannedScripsList = useSelector(state => state.orders.bannedScripsList);
    const [isBannedScrips, setIsBannedScrips] = useState(false);
    //for vertical layout
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const [marketDepthTab, setMarketDepthTab] = useState(MARKET_SEGMENT_ID.NSE_CASH);
    const productTypes = useSelector(state => state.orders.productTypes);
    const [arrProdTypes, setArrProdTypes] = useState([]);
    const [arrDervProductTypes, setArrDervProductTypes] = useState([]);
    const marketStatus = useSelector(state => state.orders.marketStatus);
    const arrOrderCartMarketPriceData = useSelector(state => state.orderCart.arrOrdersMarketPrice);
    const [arrMarketPrice, setArrMarketPrice] = useState([]);
    const [arrScripsToCheckBan, setArrScripsToCheckBan] = useState([]);
    const [bIsBannedScripAccepted, setBIsBannedScripAccepted] = useState(false);
    const [bIsBannedScripRejected, setBIsBannedScripRejected] = useState(false);
    const [bsePreTradeViolatingScrips, setBsePreTradeViolatingScrips] = useState([]);
    const [bsePreTradeMsgAccepted, setBsePreTradeMsgAccepted] = useState(false);

    const arrGridData = useSelector(state => state.recommendation.arrBasketReco);
    const objBasketRecommendation = useSelector(state => state.recommendation?.objBasketReco);

    const nOrderCartCount = getAppInfoData(APP_INFO_PARAMS?.APP_ORDERCART_ORDER_COUNT);
    //To filter data EQ data and to set in state
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    setMultiScripOrderCartGridRef(useRef());
    const inputRef = useRef();
    const objModalData = useSelector(state => state?.modals?.modalData);
    const [strIdentifyOrderCartMethod] = useState(objModalData?.data?.method);
    const [arrSymbolData, setArrSymbolData] = useState([]);
    const location = useLocation();
    let objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start */ }
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */ }
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Start
    const [arrSurvMeasureData, setArrSurvMeasureData] = useState([]);
    const [isSurvMeasure, setIsSurvMeasure] = useState(false);
    const [isGoBackConfirm, setIsGoBackConfirm] = useState(false);
    const checkGSM = getAppInfoData(APP_INFO_PARAMS.APP_GSM_GRADE_CATEGORY);
    const [totalMargin, setTotalMargin] = useState(0.00);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const [arrScripsData, setArrScripsData] = useState([]);
    const [bIsShowSearchScrip, setBIsShowSearchScrip] = useState(false);
    const [bIsShowScripDetails, setBIsShowScripDetails] = useState(false);
    const [objSelectedScrip, setObjSelectedScrip] = useState({});
    let bIsBasketReco = false;
    const [objRangeColor, setObjRangeColor] = useState({ price: 'color-text', trigger: 'color-text', limit: 'color-text' });
    const [toggleStopLoss, setToggleStopLoss] = useState(false);
    const arrOrderBackupData = useSelector(state => state?.orderCart?.arrOrderDataBackupVertical);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 -End
    const objDefaultProductType = productTypes && productTypes?.length > 0 && productTypes?.find(eachProd => eachProd.sDefaultProductType == ORDER_PRODUCT_TYPES.DELIVERY);
    const objDefaultDerivativeProductType = productTypes && productTypes?.length > 0 && productTypes?.find(eachProd => eachProd.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD);
    const arrExchangesToFilter = [EXCHANGE_NAME_API.BSE_EQ_API, EXCHANGE_NAME_API.NSE_EQ_API, EXCHANGE_NAME_API.NSE_DERV_API, EXCHANGE_NAME_API.BSE_DERV_API];
    const bIsConvertToOrderCart = useSelector(state => state?.orderCart?.bIsConvertToOrderCart);
    const arrPrevOrderInfo = useSelector(state => state.orderCart?.arrPrevOrderInfo);
    const [strMarketDepthField, setStrMarketDepthField] = useState('');
    function divideArrayIntoGroups(array, groupSize) {
        let dividedArrays = [];
        let currentIndex = 0;

        while (currentIndex < array?.length) {
            let curentGroup = array?.slice(currentIndex, currentIndex + groupSize);
            dividedArrays?.push(curentGroup);
            currentIndex += groupSize;
        }
        return dividedArrays;
    }
    //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : SAT Issue of AMO session - Start
    useEffect(() => {
        if (objSelectedScrip?.['SYMBOL']?.length > 0) {
            setIsShowMarketDepth(false);
            setMarketDepthTab(objSelectedScrip?.['SYMBOL']?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        } else { }
    }, [objSelectedScrip]); //arrDistinctScripExchanges
    useEffect(() => {
        const bIsAmoAllowed = getAppInfoData(APP_INFO_PARAMS.APP_AMO_MODE);
        if (bIsAmoAllowed) {
            dispatch(getMarketStatus());
        } else { }
        //It should run only once
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setTimeout(() => {
            if (marketStatus?.length > 0 && arrScripsData?.length > 0) {
                arrScripsData?.forEach(eachScrip => {
                    for (let i = 0; i < marketStatus.length; i++) {
                        if (getApiExchangeNameFromMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]) == marketStatus[i].exchangeSegment) {
                            if (!eachScrip.amoUpdated) {
                                if (marketStatus[i].marketStatus.toUpperCase() === 'AMO') {
                                    handleAMO({ target: { checked: true } }, eachScrip.id);
                                }
                            }
                            break;
                        } else { }
                    }
                });
            } else { }
        }, 500);
        //If we add marketStatus running continuously
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [arrScripsData]);//BREEZE-305:ManasaB : 08-01-2025 : Side tray Order cart SAT2 issue related to AMO
    useEffect(() => {
        if (productTypes?.length > 0) {
            let arrFilteredProductTypes = productTypes.filter(eachProd => eachProd.sDefaultProductType === ORDER_PRODUCT_TYPES.DELIVERY || eachProd.sDefaultProductType === ORDER_PRODUCT_TYPES.MARGIN);
            setArrProdTypes(arrFilteredProductTypes);
            let arrFilteredDerivativeProductTypes = productTypes.filter(eachProd => eachProd.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD || eachProd.sDefaultProductType === ORDER_PRODUCT_TYPES.INTRADAY);
            setArrDervProductTypes(arrFilteredDerivativeProductTypes);
        }
    }, [productTypes]);
    //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : SAT Issue of AMO session - End
    useEffect(() => {
        dispatch(updateOrdercartMargin(totalMargin));
    }, [totalMargin, dispatch]);
    const calculatedAndGetOrderMarginInfoFor = async (arrOrderInfo) => {
        let nTotalMargin = 0;
        let nTotalAvailableMargin = 0;
        dispatch(orderMarginInfoSuccess({}));
        let devidedArray = divideArrayIntoGroups(arrOrderInfo, 10);
        setTotalMargin(0.00);
        devidedArray?.forEach(async (eachGroupArray) => {
            const arrLegDetails = eachGroupArray.map((eachScrip, i) => {
                return {
                    "LegNo": i + 1,
                    "BuyOrSell": eachScrip["BUY"] === 'BUY' ? 0 : 1,
                    "MarketSegmentId": getMktSegIdFromMappedMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]),
                    "Token": eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                    "Quantity": eachScrip["QTY"],
                    "Price": Math.round(eachScrip["PRICE"] * eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                    "MktFlag": eachScrip["ORDER TYPE"].includes('MKT') ? 1 : 0,
                    "OldPrice": 0,
                    "OldQuantity": 0,
                    "ProductType": eachScrip["PROD TYPE"].includes(ORDER_PRODUCT_TYPES.DELIVERY) ? "D" : "M", //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024
                    "LegIndicator": 0
                };
            });
            let objResp = await dispatch(getOrderMarginInfo(arrLegDetails));
            let nApproxMargin = objResp?.data?.data?.result?.ApproxMargin;
            let nAvailableMargin = objResp?.data?.data?.result?.AvailableMargin;
            nTotalMargin = (parseFloat(nTotalMargin) + parseFloat(nApproxMargin)).toFixed(2);
            nTotalAvailableMargin = (parseFloat(nTotalAvailableMargin) + parseFloat(nAvailableMargin)).toFixed(2);
            setTotalMargin(nTotalMargin);
            let objMarginResult = deepClone(objResp?.data?.data?.result);
            objMarginResult.ApproxMargin = nTotalMargin;
            objMarginResult.AvailableMargin = nTotalAvailableMargin;
            dispatch(orderMarginInfoSuccess(objMarginResult));
        });

    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 End
    const BuySellDropDown = (props) => {
        const { setRowData } = props;
        const { rowIndex } = props?.node;
        const arrTransactionType = ["BUY", "SELL"];
        //BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - Start
        const handleBuySell = (e) => {
            let arrGridData = [];
            let newGridData = [];
            props?.api?.forEachNode((rowNode) => {
                arrGridData.push(rowNode?.data);
            });
            const node = props.api.getDisplayedRowAtIndex(rowIndex);
            const oldRow = node.data;
            const newId = `${e.target.scripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}_${e.target.value}`
            const bIsDuplicate = arrGridData.some(row => row.id !== oldRow.id && row.id === newId &&
                row["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL] === oldRow["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]
                && row["BUY/SELL"] === e.target.value); 
            if (bIsDuplicate) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `The selected scrip already exists in the cart.` }));
                return;
            }
            else {
                const updatedRow = {
                    ...oldRow,
                    "BUY/SELL": e.target.value,
                    "BtnColor": e.target.value === 'BUY' ? 'color-positive' : 'color-negative',
                    id: newId
                }
                props.api.applyTransaction({
                    remove: [oldRow]
                });
                props?.api.applyTransaction({
                    add: [updatedRow],
                    addIndex: rowIndex
                });
                props?.api?.forEachNode((rowNode) => {
                    newGridData.push(rowNode?.data);
                });
                setRowData([...newGridData]);
            }
            //BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - End
        };
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div data-testid={`ordercart-row-${rowIndex}-buySell-container`} className='Bzmodalselect-dropdown'>
                        <BzDropdown data-testid={`ordercart-row-${rowIndex}-buySell-dropdown`} size='sm'>
                            <Dropdown.Toggle data-testid={`ordercart-row-${rowIndex}-buySell-toggle`} className={`btn-default ${props.data['BtnColor']}`}>{props.data["BUY/SELL"]}</Dropdown.Toggle>
                            <Dropdown.Menu data-testid={`ordercart-row-${rowIndex}-buySell-dropdown-menu`}>
                                {arrTransactionType?.map((each, i) => (
                                    <Dropdown.Item data-testid={`ordercart-row-${rowIndex}-buySell-dropdown-${each}-item`} key={i} onClick={() => { handleBuySell({ target: { name: 'buySellType', value: each, scripInfo: props.data } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    const ExchangeDropDown = (props) => {
        const { rowData, setRowData } = props;
        const exchange = ["NSE", "BSE"];
        const { rowIndex } = props?.node;
        const handleExchange = async (e) => {
            let arrMarketPriceList = [];
            const arrUpdateRowData = [...rowData];
            let mktSegId = getMktSegIdFromApiExchangeName(`${e.target.value}_EQ`);
            let exchange = getApiExchangeNameFromMktSegId(mktSegId);
            let data = await getOptionChainData({
                instrumentName: SCRIP_INSTRUMENTS.EQUITIES, symbol: props.data["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL], allowedId: objLoginSession.nExchangesViewAllowed
            });
            const arrWithIndex = getSearchDataAsPerSearchIndexes(data, true);
            let arrFilteredData = arrWithIndex.find(eachData => eachData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === exchange);
            let nIndex = arrUpdateRowData.findIndex(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrFilteredData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (nIndex < 0) {
                const arrGlobalData = [...globalScripDetails];
                for (let i = 0; i < arrGlobalData.length; i++) {
                    if (arrGlobalData[i][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrUpdateRowData[rowIndex]["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                        arrGlobalData[i] = arrFilteredData;
                    }
                }
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
                sendTouchlineRequest([
                    { exchangeId: arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN]?.length !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
                ]);
                setTimeout(() => {
                    setGlobalScripDetails([...arrGlobalData]);
                    const objLastTickData = dispatch(getWfhTouchlineLastTick());
                    let arrLastTick = objLastTickData[arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrLastTick !== undefined ? arrLastTick[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                    let objMarketPrice = {
                        id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${props.data["BUY/SELL"]}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    setRowData(prevArray => {
                        const arrPrevData = [...prevArray];
                        const newObj = {
                            id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${props.data["BUY/SELL"]}`,
                            'BUY/SELL': props.data["BUY/SELL"], 'SYMBOL': arrFilteredData,
                            'EXCHANGE': arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE],
                            "ORDER TYPE": "RL-MKT",
                            "VALIDITY": arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                            "QTY": arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                            "PRICE": arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : 0,
                            "PROD TYPE": objDefaultProductType.sDescription, "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                            "AMO": false, "BtnColor": props.data["BUY/SELL"] === 'BUY' ? 'color-positive' : 'color-negative',
                            "Range": parseFloat(arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]) !== 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                            "amoUpdated": false
                        };
                        arrPrevData[rowIndex] = newObj;
                        setArrMarketPrice(arrMarketPriceList);
                        dispatch(getOrderMarketPriceList(arrMarketPriceList));
                        return arrPrevData;
                    });
                }, 200);
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
            }

            else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Selected exchange scrip is already exist in ordercart. Please choose other exchange and try again.` }));
            }
        };
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div data-testid={`ordercart-row-${rowIndex}-exchange-container`} className='Bzmodalselect-dropdown'>
                        <BzDropdown data-testid={`ordercart-row-${rowIndex}-exchange-dropdown`} size='sm'>
                            <Dropdown.Toggle data-testid={`ordercart-row-${rowIndex}-exchange-dropdown-toggle`} className={`btn-default`} disabled={props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES} >{props.data["EXCHANGE"]}</Dropdown.Toggle>
                            <Dropdown.Menu data-testid={`ordercart-row-${rowIndex}-exchange-dropdown-menu`}>
                                {exchange?.map((each, i) => (
                                    <Dropdown.Item data-testid={`ordercart-row-${rowIndex}-exchange-dropdown-${each}-item`} key={i} onClick={() => { handleExchange({ target: { name: 'exchange', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
    const onValueClick = useCallback((nValue) => {
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            let objSelectedGridData = MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.getSelectedRows()[0];
            const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objSelectedGridData["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
            const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);
            let fieldToUpdate = '';
            if (strMarketDepthField === 'price') {
                fieldToUpdate = "PRICE";
            } else if (strMarketDepthField === 'slLimit') {
                fieldToUpdate = "SL LIMIT";
            } else if (strMarketDepthField === 'slTrigger') {
                fieldToUpdate = "SL TRIGGER";
            }
            const orderType = objSelectedGridData["ORDER TYPE"];
            let isUpdateValid = false;
            if (orderType === ORDER_ENTRY_TYPES.RL && fieldToUpdate === "PRICE") {
                isUpdateValid = true;
            } else if (orderType === ORDER_ENTRY_TYPES.SL_MKT && fieldToUpdate === "SL TRIGGER") {
                isUpdateValid = true;
            } else if (orderType === ORDER_ENTRY_TYPES.SL && (fieldToUpdate === "SL LIMIT" || fieldToUpdate === "SL TRIGGER")) {
                isUpdateValid = true;
            }
            if (fieldToUpdate && isUpdateValid) {
                let objUpdatedData = { ...objSelectedGridData, [fieldToUpdate]: nValue.toFixed(decimalLocatorLength) };
                setRowData(prevData => prevData.map((eachData) => eachData.id === objUpdatedData.id ? { ...eachData, [fieldToUpdate]: nValue.toFixed(decimalLocatorLength) } : eachData));
                if (fieldToUpdate === "SL LIMIT" || fieldToUpdate === "SL TRIGGER" || fieldToUpdate === "PRICE") {
                    setBDisableSaveBtn(false);
                }
            }
        }
        else if (layoutType === LAYOUT_TYPE.VERTICAL) {
            let objToUpdate = arrScripsData.find(eachScrip => eachScrip.id === objSelectedScrip.id);
            const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(objToUpdate["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
            const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);
            let fieldToUpdate = '';
            if (strMarketDepthField === 'price') {
                fieldToUpdate = "PRICE";
            } else if (strMarketDepthField === 'slLimit') {
                fieldToUpdate = "SL LIMIT";
            } else if (strMarketDepthField === 'slTrigger') {
                fieldToUpdate = "SL TRIGGER";
            }
            const orderType = objToUpdate["ORDER TYPE"];
            let isUpdateValid = false;
            if (orderType === ORDER_ENTRY_TYPES.RL && fieldToUpdate === "PRICE") {
                isUpdateValid = true;
            } else if (orderType === ORDER_ENTRY_TYPES.SL_MKT && fieldToUpdate === "SL TRIGGER") {
                isUpdateValid = true;
            } else if (orderType === ORDER_ENTRY_TYPES.SL && (fieldToUpdate === "SL LIMIT" || fieldToUpdate === "SL TRIGGER")) {
                isUpdateValid = true;
            }
            if (fieldToUpdate && isUpdateValid) {
                setArrScripsData(prevData => prevData.map(eachData => eachData.id === objToUpdate.id ? { ...eachData, [fieldToUpdate]: nValue.toFixed(decimalLocatorLength) } : eachData));
                if (fieldToUpdate === "SL LIMIT") {
                    setTimeout(() => {
                        checkTriggerValue(objSelectedScrip);
                    }, 200);
                }
            }
        }
        //On click of value this will execute so layout type dependency not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [objSelectedScrip, arrScripsData, strMarketDepthField]);

    const checkTriggerValue = useCallback((objSelectedScripInfo) => {
        let objToUpdate = arrScripsData.find(eachScrip => eachScrip.id === objSelectedScripInfo.id);
        if (parseFloat(objToUpdate["SL TRIGGER"]) == 0) {
            setBIsPlaceOrderBtnDisabled(true);
        }
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [arrScripsData]);
    //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
    const OrderTypeDropDown = (props) => {
        const { setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        const handleOrderType = (e) => {
            props?.setValue(e.target.value);
            if (e.target.value === ORDER_ENTRY_TYPES.SL) {
                if (parseFloat(props?.data["SL TRIGGER"]) == 0 || parseFloat(props?.data["SL LIMIT"] == 0)) {
                    setBDisableSaveBtn(true);
                }

            }
            else if (e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                if (parseFloat(props?.data["SL TRIGGER"]) == 0) {
                    // setBDisableSaveBtn(true);
                }
            }
            else {
                if (e.target.value === ORDER_ENTRY_TYPES.RL_MKT) {
                    let objMarketPrice = arrOrderCartMarketPriceData.find(eachData => eachData.id === props?.data.id);
                    setRowData(prevData => prevData.map((eachData, index) => index == rowIndex ? { ...eachData, "PRICE": objMarketPrice?.price } : eachData));
                    setBDisableSaveBtn(false);
                }
                else if (e.target.value === ORDER_ENTRY_TYPES.RL) {
                    if (parseFloat(props?.data["PRICE"]) === 0) {
                        // setBDisableSaveBtn(true);
                    }
                }

            }
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.refreshCells({ force: true });
        };
        const arrOrderType = ["RL", "RL-MKT", "SL", "SL-MKT"];
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div data-testid={`ordercart-row-${rowIndex}-ordertype-container`} className='Bzmodalselect-dropdown'>
                        <BzDropdown data-testid={`ordercart-row-${rowIndex}-ordertype-dropdown`} size='sm'>
                            <Dropdown.Toggle data-testid={`ordercart-row-${rowIndex}-ordertype-dropdown-toggle`} className={`btn-default`}>{props.data["ORDER TYPE"]}</Dropdown.Toggle>
                            <Dropdown.Menu data-testid={`ordercart-row-${rowIndex}-ordertype-dropdown-menu`}>
                                {arrOrderType?.map((each, i) => (
                                    <Dropdown.Item data-testid={`ordercart-row-${rowIndex}-ordertype-dropdown-${each}-item`} key={i} onClick={() => { handleOrderType({ target: { name: 'orderType', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 15-04-2024 : Added null checkes - Start
    const ProductTypeDropDownComponent = (props) => {
        const { rowData, arrProdTypes } = props;
        const { rowIndex } = props?.node;
        const [arrProductType, setArrProductType] = useState([]);
        useEffect(() => {
            if (props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                setArrProductType(arrProdTypes);
            }
            else {
                setArrProductType(arrDervProductTypes);
            }
            //It should run once
            // eslint-disable-next-line reactHooks/exhaustive-deps
        }, []);
        const handleProductType = (e) => {
            props?.setValue(e.target.value);
            handleMarginInfo(rowData); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024
        };
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div data-testid={`ordercart-row-${rowIndex}-producttype-container`} className='Bzmodalselect-dropdown'>
                        <BzDropdown data-testid={`ordercart-row-${rowIndex}-producttype-dropdown`} size='sm'>
                            <Dropdown.Toggle data-testid={`ordercart-row-${rowIndex}-producttype-dropdown-toggle`} className={`btn-default oe-multiscrip-prod-type-select`}>{props.data["PROD TYPE"].toUpperCase()}</Dropdown.Toggle>
                            <Dropdown.Menu data-testid={`ordercart-row-${rowIndex}-producttype-dropdown-menu`}>
                                {arrProductType.map((each, i) => (
                                    <Dropdown.Item data-testid={`ordercart-row-${rowIndex}-producttype-dropdown-${each.sDescription}-item`} key={i} onClick={() => { handleProductType({ target: { name: 'productType', value: each.sDescription } }); }}>{each.sDescription}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );

    };
    const AmoComponent = (props) => {
        const { marketStatus, rowData } = props;
        const { rowIndex } = props?.node;
        const handleOnChange = () => {
            props?.setValue(!props?.getValue());
        };
        const handleAMOH = (e, id) => {
            setRowData((prevData) =>
                prevData.map(eachData => eachData.id == id ? { ...eachData, AMO: e.target.checked, amoUpdated: true } : eachData)
            );
        };

        useEffect(() => {
            setTimeout(() => {
                if (marketStatus?.length > 0 && rowData?.length > 0) {
                    rowData?.forEach(eachScrip => {
                        for (let i = 0; i < marketStatus.length; i++) {
                            if (getApiExchangeNameFromMktSegId(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]) == marketStatus[i].exchangeSegment) {
                                if (!eachScrip.amoUpdated) {
                                    if (marketStatus[i].marketStatus.toUpperCase() === 'AMO') {
                                        handleAMOH({ target: { checked: true } }, eachScrip.id);
                                    }
                                }
                                break;
                            } else { }
                        }
                    });
                } else { }
            }, 500);
        }, [rowData, marketStatus]);
        return (
            <div data-testid={`ordercart-row-${rowIndex}-amo-container`} className='d-flex align-items-start justify-content-center pt-2'>
                <div data-testid={`ordercart-row-${rowIndex}-amo-group`} className='input-group d-flex justify-content-center'>
                    <input data-testid={`ordercart-row-${rowIndex}-amo-checkbox`} type='checkbox' className='form-check-input' name="amo" checked={props.data["AMO"]} onChange={handleOnChange.bind(this)}></input>
                </div>
            </div>
        );
    };
    const ValidityDropDown = (props) => {
        const { rowIndex } = props?.node;
        const handleValidity = (e) => {
            props?.setValue(e.target.value);

        };
        const arrValidityNSE = ["DAY", "IOC"];
        const arrValidityBSE = ["EOSESS", "EOTODY", "IOC"];
        const arrValidityDropDown = props.data["EXCHANGE"] === "NSE" ? arrValidityNSE : arrValidityBSE;
        return (
            <div className='d-flex align-items-start justify-content-center'>
                {props.data &&
                    <div data-testid={`ordercart-row-${rowIndex}-validity-container`} className='Bzmodalselect-dropdown'>
                        <BzDropdown data-testid={`ordercart-row-${rowIndex}-validity-dropdown`} size='sm'>
                            <Dropdown.Toggle data-testid={`ordercart-row-${rowIndex}-validity-dropdown-toggle`} className={`btn-default`}>{props.data["VALIDITY"]}</Dropdown.Toggle>
                            <Dropdown.Menu data-testid={`ordercart-row-${rowIndex}-validity-dropdown-menu`}>
                                {arrValidityDropDown?.map((each, i) => (
                                    <Dropdown.Item data-testid={`ordercart-row-${rowIndex}-validity-dropdown-${each}-item`} key={i} onClick={() => { handleValidity({ target: { name: 'validity', value: each } }); }}>{each}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </BzDropdown>
                    </div>
                }
            </div>
        );
    };
    const QuantityComponent = (props) => {
        const { rowIndex } = props?.node;
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 :
        let nIncrementValue = parseInt(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]);
        const handleQuantity = (e) => {
            if (parseInt(e.target.value) <= 0) {
                setBDisableSaveBtn(true);
            } else if (!e?.target?.value?.includes('.') && e.target.value < 99999999)
                props?.setValue(e.target.value);
            setBDisableSaveBtn(false);
        };
        const handleIncDec = (name) => {
            switch (name) {
                case "subQuantity":
                    if (props.data["QTY"] > nIncrementValue) {
                        props.setValue(Number(props.getValue()) - nIncrementValue);
                        setBDisableSaveBtn(false);
                    } else { };
                    break;
                case "addQuantity":
                    if (props.getValue() < 99999999)
                        props.setValue(Number(props.getValue()) + nIncrementValue);
                    setBDisableSaveBtn(false);
                    break;
                default:
            }
        };
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -End
        const handleBlur = (e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
            }
            else {
                setBDisableSaveBtn(false);
            }
        };
        return (
            <>
                <div data-testid={`ordercart-row-${rowIndex}-qty-container`} className='d-flex align-items-center justify-content-center pt-2'>
                    <div data-testid={`ordercart-row-${rowIndex}-qty-group`} className='input-group position-relative'>
                        {/* BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Add Lot Size- Start */}
                        <div data-testid={`ordercart-row-${rowIndex}-qty-minus`} className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleIncDec.bind(this, "subQuantity", rowIndex)}> </div>
                        {/* ManasaB:30-09-2024 : Solved ui adjustment issue from smoketesting : Added w_100 in below classname */}
                        {props.data && <BzInputText data-testid={`ordercart-row-${rowIndex}-qty-input`} size='sm' type='text' className='font-regular text-center w_100' name="count" onChange={handleQuantity.bind(this)} value={props.data["QTY"]} onBlur={handleBlur.bind(this)} />}
                        <div data-testid={`ordercart-row-${rowIndex}-qty-plus`} className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => handleIncDec("addQuantity", rowIndex)} ></div>
                        {/* BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Add Lot Size - End */}
                    </div>

                </div>
                {(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.OPT) || (props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.FUT))) && <div className='font-medium font-size1 color-subtext range-container mt-1'>(1Lot = <span data-testid={`ordercart-row-${rowIndex}-lot-text`} className='color-text'>{props.data["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]}Qty</span>)</div>}
            </>
        );
    };
    const PriceComponent = (props) => {
        const { setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - Start
        const bDisable = !["RL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props?.data["Range"] !== '0.00-0.00' ? props?.data["Range"]?.split("-") : [];
        let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;

        const [rangeColor, setRangeColor] = useState('color-text');
        useEffect(() => {
            if ((props.data["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL)) {
                if (parseFloat(props?.getValue()) === 0) {
                    //   setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else if (parseFloat(props?.getValue()) > maxRange || parseFloat(props?.getValue()) < minRange) {
                    setRangeColor('color-error');
                }
                else {
                    // setBDisableSaveBtn(false);
                    setRangeColor('color-text');
                }
            }
            //Other dependencies not required
            // eslint-disable-next-line reactHooks/exhaustive-deps
        }, [props]);

        const handlePrice = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value?.split('.').length - 1;
            if (decimalCount > 1) {
                value = value.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props.setValue(value);
            //  setBDisableSaveBtn(false);
        };
        const onhandleMarketDepth = (arrActiveScripInformation) => {
            setStrMarketDepthField('price');
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        };
        const handleIncDec = (name) => {
            switch (name) {
                case "subPrice":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else {
                    };
                    break;
                case "addPrice": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        // setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.value) + props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK]).toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        //  setBDisableSaveBtn(false);
                        break;
                    }


                }
                default:
            }
        };
        const handleBlur = (e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue()?.toString()?.includes('.')) {
                    props?.setValue(parseFloat(props?.getValue()).toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(props?.getValue()) <= 0) {
                    //   setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    if (parseFloat(props?.getValue()) > maxRange || parseFloat(props?.getValue()) < minRange) {
                        setRangeColor('color-error');
                    }
                    else {
                        //  setBDisableSaveBtn(false);
                        setRangeColor('color-subtext');
                    }
                }
            }
        };
        return (
            <>
                <div data-testid={`ordercart-row-${rowIndex}-price-container`} className='d-flex align-items-center justify-content-center pt-2'>
                    <div data-testid={`ordercart-row-${rowIndex}-price-group`} className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div data-testid={`ordercart-row-${rowIndex}-price-minus`} className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subPrice")}> </div>
                        <BzInputText data-testid={`ordercart-row-${rowIndex}-price-input`} disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="price" onChange={(e) => handlePrice(e)} value={props?.value} onBlur={handleBlur.bind(this)} />
                        <div data-testid={`ordercart-row-${rowIndex}-price-plus`} className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addPrice")}></div>
                    </div>
                    <div data-testid={`ordercart-row-${rowIndex}-price-market-depth-icon`} className='icon-20 icon-marketdepth ms-2 me-1' onClick={() => onhandleMarketDepth(props?.data?.SYMBOL)}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };
    const SymbolComponent = (props) => {
        const [arrCartSymbolData, setArrCartSymbolData] = useState([]);
        const { rowIndex } = props?.node;

        useEffect(() => {
            if (props?.data) {
                setArrCartSymbolData(props?.data["SYMBOL"]);
            }
        }, [props]);
        return (
            <>
                {arrCartSymbolData && arrCartSymbolData?.length > 0 &&
                    <>
                        <div data-testid={`ordercart-row-${rowIndex}-symbol-container`} className='d-flex align-items-center justify-content-start pt-2'>
                            <div data-testid={`ordercart-row-${rowIndex}-symbol-group`} className='d-flex flex-column justify-content-start'>
                                <div data-testid={`ordercart-row-${rowIndex}-symbol-header`} className='d-flex align-items-center range-container my-2'>
                                    <div data-testid={`ordercart-row-${rowIndex}-symbol-name`} className='font-medium font-size2 color-text text-uppercase me-2'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                    {props?.data["ISBANNED"] && <div data-testid={`ordercart-row-${rowIndex}-symbol-banned`} className='chips-wrap'>
                                        <div className='banned-chip'>Banned</div>
                                    </div>
                                    }
                                    <span data-testid={`ordercart-row-${rowIndex}-symbol-series`} className='font-regular font-size2 color-subtext text-uppercase'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.SERIES]}</span>
                                    {arrCartSymbolData[WATCHLIST_GRID_INDEX.INSTRUMENT] !== SCRIP_INSTRUMENTS.EQUITIES && arrCartSymbolData[WATCHLIST_GRID_INDEX.EXPIRYDATE] !== 'NA' ? <span data-testid={`ordercart-row-${rowIndex}-symbol-expiry`} className='font-regular font-size2 color-subtext text-uppercase'>{arrCartSymbolData[WATCHLIST_GRID_INDEX.INSTRUMENT]?.indexOf(SCRIP_INSTRUMENTS.FUT) === 0 ? arrCartSymbolData[WATCHLIST_GRID_INDEX.EXPIRYDATE] : `${arrCartSymbolData?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(0, 2)} ${arrCartSymbolData?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(2, 5)} ${arrCartSymbolData?.[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrCartSymbolData?.[WATCHLIST_GRID_INDEX.OPTIONTYPE]}`}</span> : ''}
                                </div>
                                <div data-testid={`ordercart-row-${rowIndex}-symbol-ltp-container`} className='d-flex align-items-center range-container'>
                                    <div data-testid={`ordercart-row-${rowIndex}-symbol-ltp`} className='font-regular font-size1 color-text pe-2'>{arrCartSymbolData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] ? arrCartSymbolData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] : '0.00'}</div>
                                    <div data-testid={`ordercart-row-${rowIndex}-symbol-change`} className={`font-regular font-size1 color-text ${Number(arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) >= 0 ? 'color-positive' : 'color-negative'}`}>{arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] ? arrCartSymbolData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] : '0.00'} ({arrCartSymbolData[WATCHLIST_GRID_INDEX.LTP_PERCENT] ? arrCartSymbolData[WATCHLIST_GRID_INDEX.LTP_PERCENT] : '0.00'}%)</div>
                                </div>
                            </div>

                        </div>
                    </>
                }
            </>
        );
    };
    //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
    useEffect(() => {
        if (rowData?.length > 0) {
            dispatch(storeGridData(rowData));
        }
        //dispatch as dependency not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [rowData]);
    //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
    const SlLimitComponent = (props) => {
        const { setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        const bDisable = !["SL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props.data["Range"] !== '0.00-0.00' ? props.data["Range"]?.split("-") : [];
        let minRange = arrRange.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange.length > 0 ? parseFloat(arrRange[1]) : 0;
        const [rangeColor, setRangeColor] = useState('color-text');
        useEffect(() => {
            if (props.data["ORDER TYPE"] === 'SL') {
                if (parseFloat(props?.getValue()) === 0) {
                    //  setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else if (parseFloat(props.data["SL TRIGGER"]) === 0) {
                    setBDisableSaveBtn(true);
                }
                else {
                    if (parseInt(Number(props?.getValue())) > maxRange || parseInt(Number(props?.getValue())) < minRange) {
                        // setBDisableSaveBtn(false);
                        setRangeColor('color-error');
                    }
                }
            }
            //Other props not required
            // eslint-disable-next-line reactHooks/exhaustive-deps
        }, [props]); //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024
        const handleSlLimit = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value.split('.').length - 1;
            if (decimalCount > 1) {
                value = value?.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props?.setValue(value);
        };
        const handleBlur = (e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue().toString().includes('.')) {
                    props.setValue(parseFloat(props.getValue()).toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(props?.getValue()) <= 0) {
                    // setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - Start
                    setRangeColor('color-text');
                    if (props.data["ORDER TYPE"] === 'SL') {
                        if (parseFloat(props.data["SL TRIGGER"]) === 0) {
                            // setBDisableSaveBtn(true);
                        }
                        else {
                            // setBDisableSaveBtn(false);
                            setRangeColor('color-text');
                        }
                    }
                    else {
                        // setBDisableSaveBtn(false);
                        setRangeColor('color-text');
                    }
                    //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - End
                }
            }
        };
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
        const onhandleMarketDepth = (arrActiveScripInformation) => {
            setStrMarketDepthField('slLimit');
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        };
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
        const handleIncDec = (name) => {
            switch (name) {
                case "subSlLimit":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else { };
                    break;
                case "addSlLimit": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.getValue()) + props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        setBDisableSaveBtn(false);
                        break;
                    }

                }
                default:
            }
        };
        return (
            <>
                <div data-testid={`ordercart-row-${rowIndex}-sllimit-container`} className='d-flex align-items-center justify-content-center pt-2'>
                    <div data-testid={`ordercart-row-${rowIndex}-sllimit-group`} className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div data-testid={`ordercart-row-${rowIndex}-sllimit-minus`} className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subSlLimit")}></div>
                        <BzInputText data-testid={`ordercart-row-${rowIndex}-sllimit-input`} disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="slLimit" onChange={(e) => handleSlLimit(e)} value={props.value} onBlur={handleBlur.bind(this)} />
                        <div data-testid={`ordercart-row-${rowIndex}-sllimit-plus`} className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addSlLimit")}></div>
                    </div>
                    <div data-testid={`ordercart-row-${rowIndex}-sl-limit-market-depth-icon`} className='icon-20 icon-marketdepth ms-2 me-1' onClick={() => onhandleMarketDepth()}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };

    const SlTriggerComponent = (props) => {
        const { setBDisableSaveBtn } = props;
        const { rowIndex } = props?.node;
        const bDisable = !["SL-MKT", "SL"]?.includes(props.data["ORDER TYPE"]);
        let arrRange = props.data["Range"] !== '0.00-0.00' ? props.data["Range"]?.split("-") : [];
        let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
        let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
        const [rangeColor, setRangeColor] = useState('color-text');

        useEffect(() => {
            if (props?.data["ORDER TYPE"] === "SL") {
                if (parseFloat(props.data["SL TRIGGER"]) === 0) {
                    // setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else if (parseFloat(props.data["SL LIMIT"]) === 0) {
                    //  setBDisableSaveBtn(true);
                }
                else {
                    //  setBDisableSaveBtn(false);
                }

            }
            else if (props?.data["ORDER TYPE"] === "SL MKT") {
                if (parseFloat(props.data["SL TRIGGER"]) === 0) {
                    //  setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    // setBDisableSaveBtn(false);
                }
            }
            //Props dependency enough
            // eslint-disable-next-line reactHooks/exhaustive-deps
        }, [props]); //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024
        const handleSlTrigger = (e) => {
            e.preventDefault();
            let { value } = e.target;
            value = value?.replace(/[^0-9.]/g, '');
            let decimalCount = value?.split('.').length - 1;
            if (decimalCount > 1) {
                value = value.slice(0, value.lastIndexOf('.'));
            }
            let valueParts = value.split('.');
            if (valueParts[1] && valueParts[1].length > props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
                value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
            }
            props.setValue(value);
            //   setBDisableSaveBtn(false);
        };
        const handleIncDec = (name) => {
            switch (name) {
                case "subSlTrigger":
                    if (props?.getValue() > 0) {
                        props?.setValue((parseFloat(props?.getValue()) - props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                    } else { };
                    break;
                case "addSlTrigger": {
                    if (props?.value?.length <= 0) {
                        props?.setValue(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        // setBDisableSaveBtn(false);
                        break;
                    } else {
                        props?.setValue((parseFloat(props?.getValue()) + props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK])?.toFixed(props?.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                        //  setBDisableSaveBtn(false);
                        break;
                    }

                }
                default:
            }
        };
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - Start
        const onhandleMarketDepth = (arrActiveScripInformation) => {
            setStrMarketDepthField('slTrigger');
            setIsShowMarketDepth(curr => {
                if (!curr && props?.data?.SYMBOL?.length) {
                    dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
                }
                return !curr;
            });
            if (arrActiveScripInformation?.length !== 0) {
                makeGridRowSelected(MULTISCRIP_ORDER_CART_GRID_REF, rowIndex);
                const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
                setSupportResistance(resitancePivotObj);
            } else { }
        };
        //BT-106965 : Order Cart : ManasaB : 12/03/2024 : Adding Market Depth Value - End
        const handleBlur = (e) => {
            e.preventDefault();
            if (props?.getValue() === '') {
                setBDisableSaveBtn(true);
                setRangeColor('color-text');
            }
            else {
                if (!props?.getValue()?.toString()?.includes('.')) {
                    props.setValue(parseFloat(props?.getValue())?.toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]));
                }

                if (parseFloat(props?.getValue()) <= 0) {
                    //  setBDisableSaveBtn(true);
                    setRangeColor('color-error');
                }
                else {
                    if (parseFloat(props?.getValue()) > maxRange || parseFloat(props?.getValue()) < minRange) {
                        // setBDisableSaveBtn(true);
                        setRangeColor('color-error');
                    }
                    else {
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - Start
                        setRangeColor('color-text');
                        if (props.data["ORDER TYPE"] === 'SL') {
                            if (parseFloat(props.data["SL LIMIT"]) === 0) {
                                //   setBDisableSaveBtn(true);
                            }
                            else {
                                setBDisableSaveBtn(false);
                                setRangeColor('color-text');
                            }
                        }
                        else {
                            // setBDisableSaveBtn(false);
                            setRangeColor('color-text');
                        }
                        //BT-106965 : Ordercart :Regression : ManasaB : 26-06-2024 - End
                    }
                }
            }
        };
        return (
            <>
                <div data-testid={`ordercart-row-${rowIndex}-sltrigger-container`} className='d-flex align-items-center justify-content-center pt-2'>
                    <div data-testid={`ordercart-row-${rowIndex}-sltrigger-group`} className={`input-group position-relative ${bDisable ? 'disabled' : ''}`}>
                        <div data-testid={`ordercart-row-${rowIndex}-sltrigger-minus`} className={`icon-12 icon-order-decrease input-number-left-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "subSlTrigger")}></div>
                        <BzInputText data-testid={`ordercart-row-${rowIndex}-sltrigger-input`} disabled={bDisable} size='sm' type='text' className='font-regular text-center' name="slTrigger" onChange={handleSlTrigger.bind(this)} value={props?.value} onBlur={handleBlur.bind(this)} />
                        <div data-testid={`ordercart-row-${rowIndex}-sltrigger-plus`} className={`icon-12 icon-order-increase input-number-right-wrap ${bDisable && 'div-disabled'}`} onClick={handleIncDec.bind(this, "addSlTrigger")}></div>
                    </div>
                    <div data-testid={`ordercart-row-${rowIndex}-sltrigger-marketdepth-icon`} className='icon-20 icon-marketdepth ms-2 me-1' onClick={() => onhandleMarketDepth()}></div>
                </div>
                <div className='font-medium font-size1 color-subtext range-container mt-1'>Range: <span className={`${rangeColor}`}>{props.data["Range"]}</span></div>
            </>
        );
    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024 : Removed row data variable - End
    const CloseIconComponent = (props) => {
        const { setRowData } = props;
        const { rowIndex } = props?.node;
        const onClickCancel = () => {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - Start
            if (Object.keys(objSelectedCartRowData).length > 0 || objModalData?.data?.isGoBack) {
                let arrUpdateRowData = [];
                MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode) => {
                    arrUpdateRowData.push(rowNode?.data);
                });
                if (arrUpdateRowData?.length === 1) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Atleast one scrip should be present in order cart` }));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
                }
                else {
                    let arrCartData = [];
                    MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode) => {
                        arrCartData.push(rowNode?.data);
                    });
                    arrCartData?.splice(rowIndex, 1);
                    setRowData(deepClone([...arrCartData]));
                    dispatch(storeGridData([...arrCartData]));

                }
            }
            else {
                let arrUpdateRowData = [];
                MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode) => {
                    arrUpdateRowData.push(rowNode?.data);
                });
                arrUpdateRowData?.splice(rowIndex, 1);
                // MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.setRowData(arrUpdateRowData); //we are updating grid with updated row data
                dispatch(storeGridData(deepClone([...arrUpdateRowData])));
                setRowData(deepClone([...arrUpdateRowData]));
                if (arrUpdateRowData.length == 0) {
                    setBDisableSaveBtn(true);
                    dispatch(getBannedScripsListFailure([]));
                    setArrScripsToCheckBan([]);
                }
            }
        };
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  - End
        return (
            <div data-testid={`ordercart-row-${rowIndex}-close-container`} className='d-flex justify-content-center align-items-center pt-2'>
                <div data-testid={`ordercart-row-${rowIndex}-close-button`} className='icon-16 icon-close-fill flex-shrink-0 icon-primary' onClick={() => onClickCancel()}></div>
            </div>
        );
    };

    const generateRowData = () => {
        let orderDataInfo = [];
        let data = [];
        let arrMarketPriceList = [];
        if (location.pathname === "/ordercart") {
            if (strIdentifyOrderCartMethod === "edit") {
                orderDataInfo = convertEditCart(objSelectedCartRowData?.orders);
                //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Check for Expiry scrips and show toaster message
            } else if (strIdentifyOrderCartMethod === "create") {
                orderDataInfo = [];
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 09-04-2024 - Start
                setRowData([]);
                dispatch(storeGridData([]));
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 09-04-2024 - End
            }
            else if (strIdentifyOrderCartMethod === 'clone') {
                orderDataInfo = convertEditCart(objSelectedCartRowData?.orders);
            }
        } else {
            //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Need to remove filter to show all scrips - Start
            if (arrOrderCartOptionChainData?.length > 0) {
                orderDataInfo = [...arrOrderCartOptionChainData];
                dispatch(getOrderCartOptionChain([]));
            }
            else if (bIsConvertToOrderCart) {
                let arrOrderData = activeWatchList?.scrips?.filter(ele => arrExchangesToFilter.includes(ele[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]));
                orderDataInfo = arrOrderData?.filter(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.NSPREAD] === 0)
            }
            else if (arrData?.length > 0) {
                data = [...arrData];
            }

            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
            else if (arrGridData?.length > 0) {
                orderDataInfo = convertEditCart(objBasketRecommendation.orders);
                dispatch(updateBasketReco([]));
            }
            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
            else {
                if ((arrExchangesToFilter?.includes(orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT])) && (orderInfo[WATCHLIST_GRID_INDEX.NSPREAD] === 0)) {
                    orderDataInfo.push(orderInfo);
                }
            }
            //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Need to remove filter to show all scrips - End
        }

        const arrScripsForSubscription = orderDataInfo?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
        sendTouchlineRequest(arrScripsForSubscription);
        let arrOrderCart = orderDataInfo;
        // BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - Start
        //ManasaB : 08-10-2024 : Subscription count : Start
        return new Promise((resolve) => {
            if (data.length === 0) {
                setTimeout(() => {
                    const objLastTickData = dispatch(getWfhTouchlineLastTick());
                    let strBtn = '';
                    let btnColor = '';
                    if (activeButtonToggleIndex !== undefined) {
                        if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                            strBtn = 'BUY';
                            btnColor = 'color-positive';
                        }
                        else {
                            strBtn = 'SELL';
                            btnColor = 'color-negative';
                        }
                    }
                    else {

                        strBtn = 'BUY';
                        btnColor = 'color-positive';
                    }
                    for (let i = 0; i < arrOrderCart?.length; i++) {
                        if (arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_TRANSACTION_TYPE] && arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_TRANSACTION_TYPE] === 'BUY') {
                            strBtn = 'BUY',
                                btnColor = 'color-positive';
                        }
                        else if (arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_TRANSACTION_TYPE] && arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_TRANSACTION_TYPE] === 'SELL') {
                            strBtn = 'SELL';
                            btnColor = 'color-negative';
                        }
                        const bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders[i] !== undefined;
                        let arrLast = objLastTickData[arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                        let nRange = arrLast != undefined ? arrLast[TL_INDEX.DAILY_PRICE_RANGE] : "0.00-0.00";
                        let price = bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.LTP : (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00');
                        let objMarketPrice = {
                            id: `${arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn}`,
                            price
                        };
                        arrMarketPriceList.push(objMarketPrice);
                        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Based on scrip change product type list,Banned Scrip Validations - Start


                        let strProductType = bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.product_type : '';
                        //ManasaB : 04-11-2025 : Product type conversion : Start
                        let strConvertedProductType = '';
                        if (strProductType?.length > 0 && bObjSelectedCartRowData) {
                            if (objSelectedCartRowData?.orders[i]?.scripDetail?._InstrumentName?.includes(SCRIP_INSTRUMENTS.FUT) || objSelectedCartRowData?.orders[i]?.scripDetail?._InstrumentName?.includes(SCRIP_INSTRUMENTS.OPT)) {
                                if (strProductType === ORDER_PRODUCT_TYPES.DELIVERY) {
                                    strProductType = ORDER_PRODUCT_TYPES.CARRYFORWARD;
                                }
                            }
                            else {
                                if (objSelectedCartRowData?.orders[i]?.scripDetail?._InstrumentName?.includes(SCRIP_INSTRUMENTS.EQUITIES)) {
                                    if (strProductType === ORDER_PRODUCT_TYPES.INTRADAY && objSelectedCartRowData?.orders[i]?.requestBody.displayProductType === ORDER_PRODUCT_TYPES.INTRADAY) {
                                        strProductType = ORDER_PRODUCT_TYPES.INTRADAY;
                                    }
                                    else if (strProductType === ORDER_PRODUCT_TYPES.INTRADAY && objSelectedCartRowData?.orders[i]?.requestBody?.displayProductType === ORDER_PRODUCT_TYPES.MARGIN) {
                                        strProductType = ORDER_PRODUCT_TYPES.MARGIN;
                                    }
                                    else if (strProductType === ORDER_PRODUCT_TYPES.DELIVERY) {
                                        strProductType = objDefaultProductType.sDescription;
                                    }
                                }
                            }
                            strConvertedProductType = strProductType !== '' ? `${strProductType?.charAt(0).toUpperCase()}${strProductType?.slice(1).toLowerCase()}` : '';
                        }
                        //ManasaB : 04-11-2025 : Product type conversion : End
                        //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
                        let strRecoProdType = '';
                        if (arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_PROD_TYPE] !== '0.00' && bIsBasketReco) {
                            let objProdType = productTypes?.find(prodType => prodType?.sDefaultProductType === arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_PROD_TYPE]);
                            if (objProdType && Object.keys(objProdType)?.length > 0) {
                                strRecoProdType = objProdType?.sDescription;
                            }
                        }

                        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Based on scrip change product type list ,Banned Scrip Validations - End
                        data.push({
                            id: `${arrOrderCart[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn}`, //ManasaB : 29/02/2024 :Added trans type to differentiate id
                            'BUY/SELL': bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type : strBtn,
                            'SYMBOL': arrOrderCart[i],
                            'EXCHANGE': arrOrderCart[i][WATCHLIST_GRID_INDEX.EXCHANGE],
                            "ORDER TYPE": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.order_type : (bIsBasketReco && arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_ORDER_TYPE] !== '0.00') ? arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_ORDER_TYPE] : "RL-MKT",
                            "VALIDITY": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.validity : arrOrderCart[i][WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                            "QTY": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.quantity : arrOrderCart[i][WATCHLIST_GRID_INDEX.RECOMMENDED_LOT] > 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.RECOMMENDED_LOT] : (arrOrderCart[i][WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1),
                            "PRICE": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.LTP : Number(arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_PRICE]) > 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_PRICE] : (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00'), //Manasa :  19/03/2024 : After discussion with Samadhan changed
                            "PROD TYPE": bObjSelectedCartRowData ? strConvertedProductType : (bIsBasketReco && arrOrderCart[i][WATCHLIST_GRID_INDEX.RECO_PROD_TYPE] !== '0.00') ? strRecoProdType : arrOrderCart[i][WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                            "SL LIMIT": bObjSelectedCartRowData ? (objSelectedCartRowData?.orders[i]?.requestBody?.order_type === 'SL' ? objSelectedCartRowData?.orders[i]?.requestBody?.price : '0.00') : '0.00',
                            "SL TRIGGER": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.trigger_price : '0.00',
                            "AMO": bObjSelectedCartRowData ? objSelectedCartRowData?.orders[i]?.requestBody?.is_amo : false,
                            "BtnColor": bObjSelectedCartRowData ? (objSelectedCartRowData?.orders[i]?.requestBody?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative') : btnColor,
                            "Range": parseFloat(arrOrderCart[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]) !== 0 ? arrOrderCart[i][WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                            "amoUpdated": false,
                            "ISBANNED": false
                        });
                    }
                    //ManasaB : 08-10-2024 : Subscription count : End
                    //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
                    resolve(data);
                    setArrMarketPrice(arrMarketPriceList);
                    dispatch(getOrderMarketPriceList(arrMarketPriceList));
                }, 100);
            }
            else {
                resolve(data);
            }
        });


        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - End
    };

    useEffect(() => {
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) { //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues
            if (objModalData != null && objModalData != undefined && Object.keys(objModalData).length == 0 && objModalData.constructor == Object || (objModalData?.data != null && objModalData?.data != undefined && objModalData?.data && Object.keys(objModalData?.data)?.length === 0) || (objModalData?.data != null && objModalData?.data != undefined && Object.keys(objModalData?.data)?.includes('orderEntryTab') && objModalData?.data?.isGoback === false) || (objModalData?.rowDetails != null && objModalData?.rowDetails != undefined && Object.keys(objModalData).includes('rowDetails')) || (objModalData?.orderType != null && objModalData?.orderType != undefined && Object.keys(objModalData)?.includes('orderType'))) {
                generateRowData()?.then((data) => {
                    let arrGeneratedOrderData = data;
                    let arrScrips = [];
                    arrGeneratedOrderData.forEach((eachScrip) => {
                        if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                            arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                        }
                    });

                    setArrScripsToCheckBan(arrScrips);
                    dispatch(storeGridData(arrGeneratedOrderData)); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024  : Security Measures
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    setRowData(arrGeneratedOrderData);
                });
            }
            else if (objModalData != null && objModalData != undefined && Object.keys(objModalData)?.includes('data') && objModalData?.data != null && objModalData?.data != undefined && Object.keys(objModalData.data).includes('rowDetails')) {
                generateRowData().then((data) => {
                    let arrGeneratedOrderData = data;
                    let arrScrips = [];
                    arrGeneratedOrderData.forEach((eachScrip) => {
                        if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                            arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                        }
                    });

                    setArrScripsToCheckBan(arrScrips);
                    dispatch(storeGridData(data));
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    setRowData(data);
                });

            }

            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.isGoBack === false) {
                generateRowData()?.then((data) => {
                    let arrGeneratedOrderData = data;
                    let arrScrips = [];
                    arrGeneratedOrderData.forEach((eachScrip) => {
                        if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                            arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                        }
                    });
                    setArrScripsToCheckBan(arrScrips);
                    dispatch(storeGridData(arrGeneratedOrderData)); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measures
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    setRowData(arrGeneratedOrderData);
                });
            }
            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.isSurvMeasureRejected || bIsBannedScripRejected) {
                setArrMarketPrice([...arrOrderCartMarketPriceData]);
                let arrScrips = [];
                let arrGeneratedOrderData = [...arrData];
                arrGeneratedOrderData?.forEach((eachScrip) => {
                    if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) == 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) == 0) {
                        arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                    }
                });
                setArrScripsToCheckBan(arrScrips);
                setRowData(deepClone([...arrData]));
                dispatch(storeGridData(deepClone([...arrData])));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
            }
            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.bIsBasket && !Object.keys(objModalData?.data)?.includes('orderFrom')) {
                generateRowData()?.then((data) => {
                    let arrGeneratedOrderData = data;
                    let arrScrips = [];
                    arrGeneratedOrderData.forEach((eachScrip) => {
                        if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) == 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) == 0) {
                            arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                        }
                    });
                    setArrScripsToCheckBan(arrScrips);
                    dispatch(storeGridData(arrGeneratedOrderData)); //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measures
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    setRowData(arrGeneratedOrderData);
                });
            }
            else if (Object.keys(objModalData).length > 0 && objModalData?.data?.isSaveCartGoBack) {
                if (arrData?.length > 0) {
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    let arrScrips = arrData.map(eachScrip => ({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] }));
                    setArrScripsToCheckBan(arrScrips);
                    setRowData(deepClone([...arrData]));
                    dispatch(storeGridData(deepClone([...arrData])));
                    dispatch(saveCartSuccess(false));
                    if (objModalData?.data?.isGoback) {
                        setStrCartName(objSavedCartDetails.cartName);
                        setStrCartId(objSavedCartDetails.cartId);
                    }
                }
            }
            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
            else if (Object.keys(objModalData.length > 0) && objModalData?.data?.orderFrom === 'BasketReco') {
                bIsBasketReco = true;
                generateRowData().then((data) => {
                    dispatch(storeGridData(data));
                    setRowData(data);
                });
            }
            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End

            else {
                if (arrData?.length > 0) {
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024  - Start
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measures - Start
                    if (objModalData?.data?.isGoback) {
                        setIsGoBackConfirm(true);
                    }
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measures - End
                    setRowData(arrData);
                    setStrCartName(objSavedCartDetails.cartName);
                    setStrCartId(objSavedCartDetails.cartId);
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
                    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - Start
                    setArrMarketPrice([...arrOrderCartMarketPriceData]);
                    let arrScrips = arrData.map(eachScrip => ({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] }));
                    setArrScripsToCheckBan(arrScrips);

                    dispatch(storeGridData(deepClone([...arrData])));
                    dispatch(saveCartSuccess(false));
                    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - End
                }
            }
        }
        //It will run only once
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [objSavedCartDetails]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const generateVerticalData = () => {
        let orderDataInfo = [];
        let data = [];
        let arrMarketPriceList = [];
        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Need to remove filter to show all scrips - Start
        // orderDataInfo = activeWatchList?.scrips?.filter(ele => {
        //     if (ele?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && ele?.[WATCHLIST_GRID_INDEX.SERIES] !== 'SM') {//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 10-04-2024
        //         return ele;
        //     }
        // });
        if (orderInfo?.length > 0) {
            if ((arrExchangesToFilter.includes(orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]))) {
                // if (orderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && orderInfo[WATCHLIST_GRID_INDEX.SERIES] !== 'SM') {
                orderDataInfo.push(orderInfo);
            }
        }

        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Need to remove filter to show all scrips - End
        const arrScripsForSubscription = orderDataInfo?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
        sendTouchlineRequest(arrScripsForSubscription);
        return new Promise((resolve) => {
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let strBtn = 'BUY';
                let btnColor = 'color-positive';
                for (let i = 0; i < orderDataInfo?.length; i++) {
                    let arrLast = objLastTickData[orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrLast != undefined ? arrLast[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00');
                    let objMarketPrice = {
                        id: `${orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_ ${strBtn}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    data.push({
                        id: `${orderDataInfo[i][WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_ ${strBtn}`, //ManasaB : 29/02/2024 :Added trans type to differentiate id
                        'BUY/SELL': strBtn,
                        'SYMBOL': orderDataInfo[i],
                        'EXCHANGE': orderDataInfo[i][WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": orderDataInfo[i][WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": orderDataInfo[i][WATCHLIST_GRID_INDEX.REGULAR_LOT],
                        "PRICE": (arrLast?.length > 0 ? arrLast[TL_INDEX?.LAST_TRADE_PRICE] : '0.00'), //Manasa :  19/03/2024 : After discussion with Samadhan changed
                        "PROD TYPE": orderDataInfo[i][WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                        "SL LIMIT": '0.00',
                        "SL TRIGGER": '0.00',
                        "AMO": false,
                        "BtnColor": btnColor,
                        "Range": nRange,
                        "ActiveButtonToggleIndex": 0,
                        "amoUpdated": false,
                        "ISBANNED": false
                    });
                }
                //ManasaB : 08-10-2024 : Subscription count : End
                resolve(data);
                setArrMarketPrice(arrMarketPriceList);
                dispatch(getOrderMarketPriceList(arrMarketPriceList));
            }, 100);
            //Breeze:6672 : Side tray Order Cart Derivatives : ManasaB : 27-05-2025 : Change filter condition and modify product type -- LLD - End
        });

    };
    useEffect(() => {
        return () => {
            if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
                let arrRowData = [...rowData];
                const arrScripsForUnSubscription = arrRowData?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
                sendTouchlineRequest(arrScripsForUnSubscription);
            }
            else if (layoutType === LAYOUT_TYPE.VERTICAL) {
                let arrRowData = [...arrScripsData];
                const arrScripsForUnSubscription = arrRowData?.map(scrip => ({ exchangeId: getMktSegIdFromMappedMktSegId(scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]), token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
                sendTouchlineRequest(arrScripsForUnSubscription);

            }
        };
        //It should run once only
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            if ((arrExchangesToFilter.includes(orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]))) {
                const prevOrder = arrPrevOrderInfo;
                const hasChanged = !isEqual(prevOrder, orderInfo);
                if (hasChanged) {
                    generateVerticalData()?.then(response => {
                        let arrData = response;
                        let arrScrips = [];
                        arrData.forEach((eachScrip) => {
                            if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                                arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                            }
                        });
                        setArrScripsData([...arrData]);
                        calculatedAndGetOrderMarginInfoFor(arrData);
                        setArrScripsToCheckBan([...arrScrips]);

                        {/* Breeze:6672 : Side tray Order Cart Derivatives : ManasaB : 27-05-2025 : Ban scrip validation -- LLD  */ }
                        dispatch(getOrderDataBackupVertical([...arrData]));
                        dispatch(updatePrevOrderData(orderInfo));
                    });
                }
                else {
                    setArrScripsData(arrOrderBackupData);
                }

            }
        }
        //Other dependencies not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [orderInfo, bIsSaveCartBack]);
    // useEffect(() => {
    //     //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
    //     if (layoutType === LAYOUT_TYPE.VERTICAL && !bIsConfirmBack && !bIsSaveCartBack) {
    //         if (arrOrderBackupData?.length === 0) {
    //             generateVerticalData()?.then(response => {
    //                 let arrData = response;
    //                 setArrScripsData([...arrData]);
    //                 dispatch(getOrderDataBackupVertical([...arrData]));
    //             });
    //         }
    //         else {
    //             setArrMarketPrice([...arrOrderCartMarketPriceData]);
    //             setArrScripsData([...arrOrderBackupData]);
    //         }
    //     }
    //     //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
    //     //Others not required
    //     // eslint-disable-next-line reactHooks/exhaustive-deps
    // }, [activeWatchList, bIsConfirmBack,orderInfo]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    useEffect(() => {
        if (strIdentifyOrderCartMethod === undefined && objModalData?.data?.isGoBack === false && strIdentifyOrderCartMethod === 'clone') { //BT-106965  : OrderCart : SAT2 Issues : 03-05-2024
            setStrCartName('');
        }
    }, [strIdentifyOrderCartMethod, strCartName, objModalData]);
    const handleMarginInfo = (arrOrderInfo) => {
        calculatedAndGetOrderMarginInfoFor(arrOrderInfo);
    };

    useEffect(() => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        if (rowData?.length > 0) {
            const arrRowData = [...rowData];
            const arrSymbolInfo = arrRowData?.map(eachData => {
                return eachData["SYMBOL"];
            });
            setArrSymbolData(arrSymbolInfo);
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
    }, [rowData]);
    const columnDefs = useMemo(() => {
        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - Start
        return [
            {
                field: "BUY/SELL", suppressMovable: true,
                suppressNavigable: true, cellRenderer: BuySellDropDown, cellRendererParams: { rowData, setRowData }, maxWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SYMBOL", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SymbolComponent, cellRendererParams: { rowData, setRowData }, minWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "EXCHANGE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ExchangeDropDown, cellRendererParams: { rowData, setRowData }, maxWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "PROD TYPE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ProductTypeDropDownComponent, cellRendererParams: { rowData, setRowData, arrProdTypes }, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "ORDER TYPE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: OrderTypeDropDown, cellRendererParams: { rowData, setRowData, setBDisableSaveBtn }, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "QTY", suppressMovable: true,
                suppressNavigable: true, cellRenderer: QuantityComponent, cellRendererParams: { rowData, setRowData }, minWidth: 150, resizable: false, sortable: false, menuTabs: []  //ManasaB:30-09-2024 : Solved ui adjustment issue from smoketesting
            },
            {
                field: "PRICE", suppressMovable: true,
                suppressNavigable: true, cellRenderer: PriceComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SL TRIGGER", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SlTriggerComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "SL LIMIT", suppressMovable: true,
                suppressNavigable: true, cellRenderer: SlLimitComponent, cellRendererParams: { rowData, setRowData, bDisableSaveBtn, setBDisableSaveBtn }, minWidth: 250, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "VALIDITY", suppressMovable: true,
                suppressNavigable: true, cellRenderer: ValidityDropDown, cellRendererParams: { rowData, setRowData }, maxWidth: 100, resizable: false, sortable: false, menuTabs: []
            },
            {
                headerName: 'AMO', suppressMovable: true,
                suppressNavigable: true, field: 'AMO', cellRenderer: AmoComponent, cellRendererParams: { rowData, setRowData, marketStatus }, maxWidth: 40, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: '', headerName: '', suppressMovable: true,
                suppressNavigable: true, cellRenderer: CloseIconComponent, pinned: 'right', cellRendererParams: { rowData, setRowData, setGlobalScripDetails }, sortable: false, menuTabs: []
            }
        ];
        //BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - End
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [rowData, marketStatus]);

    const checkBuyExisting = (scrip) => {  // ManasaB : 08-01-2025 : Disabling Buy when same scrip is already present in search list
        let arrGridData = [];
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            arrGridData = [...rowData];
        }
        else {
            arrGridData = [...arrScripsData];
        }
        const segmentToken = scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN];
        const buyId = `${segmentToken}_BUY`;
        const bIsExist = arrGridData.some(row => row.id === buyId);
        return bIsExist;
    }; // ManasaB : 08-01-2025 : Disabling Buy when same scrip is already present in search list
    const checkSellExisting = (scrip) => {
        let arrGridData = [];
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            arrGridData = [...rowData];
        }
        else {
            arrGridData = [...arrScripsData];
        }
        const segmentToken = scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN];
        const sellId = `${segmentToken}_SELL`;
        const bIsExist = arrGridData.some(row => row.id === sellId);
        return bIsExist;
    };
    const handleArrAgGridRowData = useCallback((arrTouchLineData) => {
        const arrUpdatedRowData = [...rowData];
        let aIndex = arrUpdatedRowData?.findIndex((eachScrip) => (getMktSegIdFromMappedMktSegId(eachScrip?.SYMBOL[WATCHLIST_GRID_INDEX?.MAPPED_SEGMENT_ID]) + '_' + eachScrip?.SYMBOL[WATCHLIST_GRID_INDEX?.TOKEN] === arrTouchLineData[TL_INDEX?.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX?.TOKEN]));
        if (aIndex >= 0) {

            const arrScripToBeUpdated = arrUpdatedRowData[aIndex];
            let arrUpdatedScrips = arrScripToBeUpdated['SYMBOL'];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[TL_INDEX.BUY_QTY];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[TL_INDEX.SELL_QTY];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[TL_INDEX.HIGH_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[TL_INDEX.LOW_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[TL_INDEX.OPEN_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[TL_INDEX.VOLUME];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];
            arrUpdatedScrips[WATCHLIST_GRID_INDEX.TOKEN] = arrTouchLineData[TL_INDEX.TOKEN];
            arrScripToBeUpdated['SYMBOL'] = arrUpdatedScrips;
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api.applyTransaction({
                update: [arrScripToBeUpdated]
            });
        } else { }
    }, [rowData]);
    useEffect(() => {
        if (rowData?.length > 0) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            rowData.forEach(eachData => {
                const arrLastTickScripData = objLastTickData[eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
                if (arrLastTickScripData?.length > 0) {
                    handleArrAgGridRowData([...arrLastTickScripData]);
                } else { }
            });

        } else { }
        return () => {
            const arrDistinctScripExchangesSubscription = rowData?.map(eachData => ({ exchangeId: eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], token: eachData["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);
        };
        //handleArrAgGridRowData not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [rowData, dispatch]);

    useWFHMessages('touchline', (e) => {
        // handleArrGridRowData([...e.detail]);
        handleArrAgGridRowData([...e.detail]);
    });


    //To get( LTP & LTP&  & Change in LTP) from WFH to newly added EQ Scrip From Search
    const handleMarketDataForScrips = useCallback((touchlineData) => {
        const addedScrips = scripAddedInfo;
        let nindex = addedScrips.findIndex(eachIndex => eachIndex[WATCHLIST_GRID_INDEX.SEGMENT_ID] === touchlineData[TL_INDEX.SEGMENT_ID] && eachIndex[WATCHLIST_GRID_INDEX.TOKEN] === touchlineData[TL_INDEX.TOKEN]);
        if (nindex >= 0 && addedScrips[nindex][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] === "") {
            addedScrips[nindex][WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = touchlineData[TL_INDEX.LAST_TRADE_PRICE];
            addedScrips[nindex][WATCHLIST_GRID_INDEX.LTP_PERCENT] = touchlineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];

            addedScrips[nindex][WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = touchlineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            setGlobalScripDetails([...addedScrips]);
        }
    }, [scripAddedInfo]);
    //To GET WFH data
    useWFHMessages('touchline', (e) => {
        handleMarketDataForScrips(e.detail);
    });


    const onBuySellClick = useCallback((strBuySell, scrip) => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : To restrict scrips SM scrips - Start
        let arrMarketPriceList = [];
        if (arrExchangesToFilter?.includes(scrip[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT]) && (scrip[WATCHLIST_GRID_INDEX.NSPREAD] === 0)) {
            if (scrip[WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) == 0 || scrip[WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) == 0) {
                let objSegToken = { mktSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN] };
                dispatch(getBannedScripStatus(objSegToken)).then(response => {
                    if (response?.data?.result.length > 0 && response?.data?.result[0][""] == 1) {
                        setIsBannedScrips(true);
                        dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': true }]));
                        let arrBannedMessage = [{ name: scrip[WATCHLIST_GRID_INDEX.SYMBOL], expiry: scrip[WATCHLIST_GRID_INDEX.EXPIRYDATE] }];
                        dispatch(handleModalData({ data: { bannedMessage: arrBannedMessage, buySellClick: true, scripInfo: scrip, strBuySell } }));
                    }
                    else {
                        setIsFlag(1);
                        setStrSearchInputText('');
                        sendTouchlineRequest([
                            { exchangeId: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: scrip[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
                        ]);

                        setTimeout(() => {
                            const arrUpdatedRowData = layoutType == LAYOUT_TYPE.HORIZONTAL ? [...rowData] : arrScripsData;
                            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
                            if (arrUpdatedRowData.length < nOrderCartCount) {
                                let btnColor = '';
                                if (strBuySell.toUpperCase() == 'BUY') {
                                    btnColor = 'color-positive';
                                }
                                else {
                                    btnColor = 'color-negative';
                                }
                                let strBUYSELL = strBuySell.toUpperCase();
                                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                                let arrScrip = objLastTickData[scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                                let nRange = arrScrip != undefined ? arrScrip[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                                let price = arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                                let objMarketPrice = {
                                    id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`,
                                    price
                                };
                                arrMarketPriceList.push(objMarketPrice);
                                const objScrip = {
                                    id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`, //ManasaB : 29/02/2024 : Added trans type to differentiate id
                                    'BUY/SELL': strBuySell.toUpperCase(),
                                    'SYMBOL': scrip, 'EXCHANGE': scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                                    "ORDER TYPE": "RL-MKT",
                                    "VALIDITY": scrip[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                                    "QTY": scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                                    "PRICE": arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                                    "PROD TYPE": scrip[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                                    "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                                    'AMO': false, 'BtnColor': btnColor,
                                    "Range": scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] != 0 ? scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                                    "ActiveButtonToggleIndex": strBuySell.toUpperCase() == 'BUY' ? 0 : 1,
                                    amoUpdated: false,
                                    "ISBANNED": false

                                };
                                if (objScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                                    setScripAddedInfo(curr => [...curr, scrip]);
                                    setGlobalScripDetails(curr => [...curr, scrip]);
                                }
                                if (checkGSM === FACILITY_STR.ON && scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== null) {
                                    let objSurvMeasure = {
                                        marketSegmentId: scrip[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                                        token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                                        cautionaryText: scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                                        textString: `${scrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${scrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${scrip[WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`,
                                        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
                                        symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL] + '-' + scrip[WATCHLIST_GRID_INDEX.SERIES],
                                        buySell: strBuySell?.toUpperCase() === ORDER_ENTRY_BUY_SELL_TEXT.BUY ? CAUTIONARY_TRANSACTION_TYPE.BUY : CAUTIONARY_TRANSACTION_TYPE.SELL
                                        //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
                                    };
                                    setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                                }
                                arrUpdatedRowData.push(objScrip);
                                setArrMarketPrice(arrMarketPriceList);
                                dispatch(getOrderMarketPriceList(arrMarketPriceList));
                                if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                                    // MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                                    //     update: [arrUpdatedRowData]
                                    // });
                                    setRowData([...arrUpdatedRowData]);
                                    dispatch(storeGridData([...arrUpdatedRowData]));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024

                                }
                                else {
                                    calculatedAndGetOrderMarginInfoFor(arrUpdatedRowData); //ManasaB : 17-10-2024 : Fixed infinite api call for getOrderMarginInfo api for side tray order cart
                                    setArrScripsData([...arrUpdatedRowData]);
                                    dispatch(getOrderDataBackupVertical([...arrUpdatedRowData]));
                                }
                                let arrScrips = [];
                                arrUpdatedRowData.forEach((eachScrip) => {
                                    if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                                        arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                                    }
                                });
                                if (arrScrips.length > 0) {
                                    setArrScripsToCheckBan(arrScrips);
                                }
                            }
                            else {
                                dispatch(setShowSideTrayPlaceOrder(true));
                                dispatch((toastConfig({ autoDismiss: true, show: true, message: `You cannot add more than ${nOrderCartCount} in single cart.` })));
                            }
                        }, 200);
                    }
                });
            }
            else {
                setIsFlag(1);
                setStrSearchInputText('');
                sendTouchlineRequest([
                    { exchangeId: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: scrip[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
                ]);

                setTimeout(() => {
                    const arrUpdatedRowData = layoutType == LAYOUT_TYPE.HORIZONTAL ? [...rowData] : arrScripsData;
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
                    if (arrUpdatedRowData.length < nOrderCartCount) {
                        let btnColor = '';
                        if (strBuySell.toUpperCase() == 'BUY') {
                            btnColor = 'color-positive';
                        }
                        else {
                            btnColor = 'color-negative';
                        }
                        let strBUYSELL = strBuySell.toUpperCase();
                        const objLastTickData = dispatch(getWfhTouchlineLastTick());
                        let arrScrip = objLastTickData[scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                        let nRange = arrScrip != undefined ? arrScrip[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                        let price = arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                        let objMarketPrice = {
                            id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`,
                            price
                        };
                        arrMarketPriceList.push(objMarketPrice);
                        const objScrip = {
                            id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`, //ManasaB : 29/02/2024 : Added trans type to differentiate id
                            'BUY/SELL': strBuySell.toUpperCase(),
                            'SYMBOL': scrip, 'EXCHANGE': scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                            "ORDER TYPE": "RL-MKT",
                            "VALIDITY": scrip[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                            "QTY": scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                            "PRICE": arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                            "PROD TYPE": scrip[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                            "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                            'AMO': false, 'BtnColor': btnColor,
                            "Range": scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] != 0 ? scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                            "ActiveButtonToggleIndex": strBuySell.toUpperCase() == 'BUY' ? 0 : 1,
                            amoUpdated: false

                        };
                        if (objScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                            setScripAddedInfo(curr => [...curr, scrip]);
                            setGlobalScripDetails(curr => [...curr, scrip]);
                        }
                        if (checkGSM == FACILITY_STR.ON && scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] != null) {
                            let objSurvMeasure = {
                                marketSegmentId: scrip[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                                token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                                cautionaryText: scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                                textString: `${scrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${scrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${scrip[WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`,
                                //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
                                symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL] + '-' + scrip[WATCHLIST_GRID_INDEX.SERIES],
                                buySell: strBuySell.toUpperCase() === ORDER_ENTRY_BUY_SELL_TEXT.BUY ? CAUTIONARY_TRANSACTION_TYPE.BUY : CAUTIONARY_TRANSACTION_TYPE.SELL
                                //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
                            };
                            setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                        }
                        arrUpdatedRowData.push(objScrip);
                        setArrMarketPrice(arrMarketPriceList);
                        dispatch(getOrderMarketPriceList(arrMarketPriceList));
                        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                                update: [arrUpdatedRowData]
                            });
                            setRowData([...arrUpdatedRowData]);
                            dispatch(storeGridData([...arrUpdatedRowData]));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024

                        }
                        else {
                            calculatedAndGetOrderMarginInfoFor(arrUpdatedRowData); //ManasaB : 17-10-2024 : Fixed infinite api call for getOrderMarginInfo api for side tray order cart
                            setArrScripsData([...arrUpdatedRowData]);
                            dispatch(getOrderDataBackupVertical([...arrUpdatedRowData]));
                        }
                        let arrScrips = [];
                        arrUpdatedRowData.forEach((eachScrip) => {
                            if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                                arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                            }
                        });
                        if (arrScrips.length > 0) {
                            setArrScripsToCheckBan([...arrScrips]);
                        }
                    }
                    else {
                        dispatch(setShowSideTrayPlaceOrder(true));
                        dispatch((toastConfig({ autoDismiss: true, show: true, message: `You cannot add more than ${nOrderCartCount} in single cart.` })));
                    }
                }, 200);
            }
        }
        else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `You cannot add currency and commodity and spread scrip.` }));
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : To restrict scrips SM scrips - End
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End
        //Others are not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [rowData, scripAddedInfo, dispatch, arrScripsData, bIsPlaceOrderBtnDisabled]);
    const onChangeTabSearch = (e) => {
        const { value } = e.target;
        setStrSearchInputText(value);
        setOrderBookSearchModal(true);
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - Start
        if (value && value.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            useDebounce(() => {
                dispatch(getSearchAllScrips(value?.toUpperCase(), objLoginSession?.nExchangesViewAllowed ? objLoginSession?.nExchangesViewAllowed : -1, 0, MAX_SEARCH_SCRIP_PER_PAGE));
            }, 1000);
        }
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - End
    };
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measure - Start
    useEffect(() => {
        if (bannedScripsList?.length > 0) {
            let arrRowData = layoutType === LAYOUT_TYPE.HORIZONTAL ? rowData : [...arrScripsData];
            if (layoutType === LAYOUT_TYPE.HORIZONTAL && objModalData?.data?.isGoback) {
                arrRowData = [...arrData];
            }
            arrRowData.forEach(eachRow => {
                bannedScripsList.forEach(eachScrip => {
                    if (eachRow["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] === eachScrip.nToken) {
                        eachRow["ISBANNED"] = true;
                    }
                });
            });
            if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
                setRowData(arrRowData);
            }
            else if (layoutType === LAYOUT_TYPE.VERTICAL) {
                setArrScripsData(arrRowData);
            }
        }
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [bannedScripsList]);

    useEffect(() => {
        if (isSurvMeasure) {
            dispatch(handleModal([{ 'SURV_MEASURE': true }]));
        }
        else {
            //BT-106965 : Order Cart : Cart name modal issue : ManasaB : 23-07-2024 - Start
            if (Object.keys(objModalData)?.includes('data')) {
                //ManasaB:03-SEP-24 :Not opening save modal - Start
                if (Object.keys(objModalData?.data)?.includes('isSurvMeasureAccepted')) {
                    if (objModalData?.data?.isSurvMeasureAccepted) {
                        if (bannedScripsList?.length > 0) {
                            let arrBannedMessage = [];
                            bannedScripsList.forEach(eachScrip => {
                                if (eachScrip.nBanFlag == 1) {
                                    arrBannedMessage.push({ name: eachScrip.sSymbol, expiry: eachScrip.nExpiryDate });
                                }
                            });
                            setIsBannedScrips(true);
                            dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': true }]));
                            dispatch(handleModalData({ data: { bannedMessage: arrBannedMessage } }));
                        }
                        else {
                            dispatch(setShowSideTrayPlaceOrder(false));
                            setBIsShowCreateCart(true);
                            saveCartData();
                        }
                    }
                }
                //ManasaB:03-SEP-24 :Not opening save modal - End
            }
            else {

            }
            //BT-106965 : Order Cart : Cart name modal issue : ManasaB : 23-07-2024 - End
        }
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [isSurvMeasure]);
    const saveCartData = () => {
        //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - Start
        let arrOrderCartData = [];
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
            setBIsBannedScripAccepted(false);

            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode) => {
                arrOrderCartData.push(rowNode?.data);
            });
        }
        else {
            setIsSurvMeasure(false);
            // dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(handleModalData({ data: {} }));
            arrOrderCartData = [...arrScripsData];
        }
        //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - End
        const bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders.length > 0; //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
        var arrOrderData = [];
        if (arrOrderCartData?.length != 0) {
            arrOrderCartData?.forEach((ele, i) => {
                let strProdType = ele["PROD TYPE"] === objDefaultProductType?.sDescription ? objDefaultProductType?.sDefaultProductType : ele["PROD TYPE"];
                let objData = {
                    id: i + 1,
                    buySellType: ele["BUY/SELL"],
                    productType: strProdType,
                    sDefaultProductType: objDefaultProductType?.sDefaultProductType,
                    orderType: ele["ORDER TYPE"],
                    validity: ele["VALIDITY"],
                    exchange: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE],
                    count: ele["QTY"],
                    amo: ele["AMO"],
                    slTrigger: ele["SL TRIGGER"],
                    slLimit: ele["SL LIMIT"],
                    price: ele["PRICE"],
                    exchangeId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                    token: ele["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                    decimalLocator: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                    decimalLocatorLength: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                    symbol: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL],
                    series: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                    instrument: ele["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT],
                    exchangeSegment: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                    isinCode: ele["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE],
                    securityDesc: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                    expiryDate: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE],
                    strikePrice: ele["SYMBOL"][WATCHLIST_GRID_INDEX.STRIKEPRICE],
                    optionType: ele["SYMBOL"][WATCHLIST_GRID_INDEX.OPTIONTYPE],
                    priceTick: ele["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],//BT-106965 : Ordercart : SAT2 Issues : ManasaB : 11-06-2024
                    mappedSegId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                    marketLot: ele["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT],// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                    maturityDate: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MATURITY_DATE],
                    expiryInMilliSec: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRY_IN_MILLISEC],
                    sSurvMeasureDescription: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]
                };
                arrOrderData.push(objData);
            });
            //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - Start
            if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                dispatch(storeGridData(arrOrderCartData));
                dispatch(handleModal([{ 'ORDER_CART_NAME_MODAL': true }, { 'ORDER_ENTRY_MODAL': false }]));
                dispatch(handleModalData({
                    data: {
                        orderCartInfo: arrOrderData,
                        orderEntryTab: 'multi_scrip', activeTabKey: 'basket',
                        method: strIdentifyOrderCartMethod,
                        ordercartName: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartName) : strCartName,
                        strOrderCartId: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartId) : strCartId, isGoback: (objModalData?.data?.isGoBack) ? objModalData?.data?.isGoBack : isGoBackConfirm //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024
                    }
                }));
                setStrCartName('');
                dispatch(convertToOrderCart(false));
            }
            else {
                dispatch(getOrderDataBackupVertical([...arrScripsData]));
                dispatch(setShowSideTrayPlaceOrder(false));
                setBIsShowCreateCart(true);
                dispatch(getOrderCartScrps(arrOrderData));
            }
            //BT-106965 : OrderCart - SideTray : ManasaB : 29-07-2024 : Security measure issue - End
        }
        // else {
        //     dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cart is Empty` }));
        // }
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End

    };
    useEffect(() => {
        if (arrScripsToCheckBan?.length > 0) {
            let payload = { 'scrip_info': arrScripsToCheckBan };
            dispatch(getBannedScripsList(payload));
        }
    }, [arrScripsToCheckBan, dispatch]);
    useEffect(() => {
        if (bIsBannedScripAccepted) {
            setIsBannedScrips(false);
            saveCartData();
        }
        //Remaining variables not required in the list
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [bIsBannedScripAccepted]);
    useEffect(() => {
        if (objModalData?.data?.addScrip) {
            let scrip = objModalData?.data?.scripInfo;
            let strBuySell = objModalData?.data?.strBuySell;
            let arrMarketPriceList = [];
            setIsFlag(1);
            setStrSearchInputText('');
            sendTouchlineRequest([
                { exchangeId: scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: scrip[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? scrip[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
            ]);

            setTimeout(() => {
                const arrUpdatedRowData = layoutType == LAYOUT_TYPE.HORIZONTAL ? [...rowData] : arrScripsData;
                //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
                if (arrUpdatedRowData.length < nOrderCartCount) {
                    let btnColor = '';
                    if (strBuySell.toUpperCase() == 'BUY') {
                        btnColor = 'color-positive';
                    }
                    else {
                        btnColor = 'color-negative';
                    }
                    let strBUYSELL = strBuySell.toUpperCase();
                    const objLastTickData = dispatch(getWfhTouchlineLastTick());
                    let arrScrip = objLastTickData[scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                    let nRange = arrScrip != undefined ? arrScrip[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                    let price = arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                    let objMarketPrice = {
                        id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`,
                        price
                    };
                    arrMarketPriceList.push(objMarketPrice);
                    const objScrip = {
                        id: `${scrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${strBUYSELL}`, //ManasaB : 29/02/2024 : Added trans type to differentiate id
                        'BUY/SELL': strBuySell.toUpperCase(),
                        'SYMBOL': scrip, 'EXCHANGE': scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": scrip[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? scrip[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                        "PRICE": arrScrip?.length > 0 ? arrScrip[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                        "PROD TYPE": scrip[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                        "SL LIMIT": '0.00', "SL TRIGGER": '0.00',
                        'AMO': false, 'BtnColor': btnColor,
                        "Range": scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] != 0 ? scrip[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                        "ActiveButtonToggleIndex": strBuySell.toUpperCase() == 'BUY' ? 0 : 1,
                        amoUpdated: false,
                        "ISBANNED": true

                    };
                    if (objScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] != scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
                        setScripAddedInfo(curr => [...curr, scrip]);
                        setGlobalScripDetails(curr => [...curr, scrip]);
                    }
                    if (checkGSM == FACILITY_STR.ON && scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] != null) {
                        let objSurvMeasure = {
                            marketSegmentId: scrip[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                            token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                            cautionaryText: scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                            textString: `${scrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${scrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${scrip[WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${scrip[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`,
                            //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
                            symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL] + '-' + scrip[WATCHLIST_GRID_INDEX.SERIES],
                            buySell: strBuySell?.toUpperCase() === ORDER_ENTRY_BUY_SELL_TEXT.BUY ? CAUTIONARY_TRANSACTION_TYPE.BUY : CAUTIONARY_TRANSACTION_TYPE.SELL
                            //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
                        };
                        setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                    }
                    arrUpdatedRowData.push(objScrip);
                    setArrMarketPrice(arrMarketPriceList);
                    dispatch(getOrderMarketPriceList(arrMarketPriceList));
                    if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                        MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.applyTransaction({
                            update: [arrUpdatedRowData]
                        });
                        setRowData([...arrUpdatedRowData]);
                        dispatch(storeGridData([...arrUpdatedRowData]));// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024

                    }
                    else {
                        calculatedAndGetOrderMarginInfoFor(arrUpdatedRowData); //ManasaB : 17-10-2024 : Fixed infinite api call for getOrderMarginInfo api for side tray order cart
                        setArrScripsData([...arrUpdatedRowData]);
                        dispatch(getOrderDataBackupVertical([...arrUpdatedRowData]));
                    }
                    let arrScrips = [];
                    arrUpdatedRowData.forEach((eachScrip) => {
                        if (eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].indexOf(SCRIP_INSTRUMENTS.OPT) === 0) {
                            arrScrips.push({ 'mktSegmentId': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID], 'token': eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN] });
                        }
                    });
                    if (arrScrips.length > 0) {
                        setArrScripsToCheckBan([...arrScrips]);
                    }
                }
                else {
                    dispatch(setShowSideTrayPlaceOrder(true));
                    dispatch((toastConfig({ autoDismiss: true, show: true, message: `You cannot add more than ${nOrderCartCount} in single cart.` })));
                }
            }, 200);
        }
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [objModalData]);

    const checkBsePreTradeValidation = (arrOrderCartData) => {
        const arrViolatingScrips = [];
        arrOrderCartData.forEach(eachHoldingScrip => {
            if (eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_DERV_API && eachHoldingScrip["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL && (eachHoldingScrip["PROD TYPE"] === ORDER_PRODUCT_TYPES.INTRADAY || eachHoldingScrip["PROD TYPE"] === ORDER_PRODUCT_TYPES.CARRYFORWARD)) {
                switch (eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT]) {
                    case SCRIP_INSTRUMENTS.FUTIDX: {
                        if (eachHoldingScrip["SL TRIGGER"] <= 10000) {
                            if (Math.abs(eachHoldingScrip["SL LIMIT"] - eachHoldingScrip["SL TRIGGER"]) > 200) {
                                arrViolatingScrips.push(eachHoldingScrip);
                            }
                        }
                        else {
                            if (Math.abs(eachHoldingScrip["SL LIMIT"] - eachHoldingScrip["SL TRIGGER"]) > (eachHoldingScrip["SL TRIGGER"] * 2) / 100) {
                                arrViolatingScrips.push(eachHoldingScrip);
                            }
                        }
                        break;
                    }
                    case SCRIP_INSTRUMENTS.OPTIDX: {
                        if (eachHoldingScrip["SL TRIGGER"] <= 50) {
                            if (Math.abs(eachHoldingScrip["SL LIMIT"] - eachHoldingScrip["SL TRIGGER"]) > 10) {
                                arrViolatingScrips.push(eachHoldingScrip);
                            }
                        }
                        else {
                            if (Math.abs(eachHoldingScrip["SL LIMIT"] - eachHoldingScrip["SL TRIGGER"]) > (eachHoldingScrip["SL TRIGGER"] * 20) / 100) {
                                arrViolatingScrips.push(eachHoldingScrip);
                            }
                        }
                        break;
                    }
                }
            }
        });
        return arrViolatingScrips;
    }

    const handleOpenOrderNameModal = useCallback(() => {
        //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
        let arrOrderCartData = [];
        let bObjSelectedCartRowData = false;
        let bIsExchangeNotAllowed = false;
        let arrExchangesNotAllowed = [];
        if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
            MULTISCRIP_ORDER_CART_GRID_REF?.current?.api?.forEachNode((rowNode) => {
                arrOrderCartData.push(rowNode?.data);
            });
            bObjSelectedCartRowData = Object?.keys(objSelectedCartRowData)?.length > 0 && objSelectedCartRowData?.orders.length > 0; //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
        }
        else {
            arrOrderCartData = [...arrScripsData];
        }
        //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
        arrOrderCartData?.forEach(eachScrip => {
            if (!(_checkSegmetAllowed(eachScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], objLoginSession?.data?.exchanges))) {
                bIsExchangeNotAllowed = true;
                if (arrExchangesNotAllowed?.length === 0) {
                    arrExchangesNotAllowed.push(eachScrip["EXCHANGE"]);
                }
                else {
                    if (!(_checkSegmetAllowed(eachScrip["EXCHANGE"]), arrExchangesNotAllowed)) {
                        arrExchangesNotAllowed.push(eachScrip["EXCHANGE"]);
                    }
                }
            }
        });
        if (bIsExchangeNotAllowed) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `${TRADING_NOT_ALLOWED_MSG_BASKET} ${arrExchangesNotAllowed.join(', ')}` }));
            return;
        }
        else {
            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - Start
            let arrSurvMeasuresData = [];
            if (arrOrderCartData?.length <= nOrderCartCount) {
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 10-05-2024 : To restrict scrip which price is not multiple of price tick - Start
                let bPriceValidation = false;
                let bQtyValidation = false;
                let strPrice = '';
                let bIsShortSellValidationFailed = false;
                let arrHoldingFailedScrips = [];
                arrOrderCartData?.forEach(eachData => {
                    let scripPrice = '';
                    let nScripPrice = '';
                    let nTriggerPrice = '';

                    if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL) {
                        if (eachData["PRICE"] > 0)
                            scripPrice = eachData["PRICE"];
                    }
                    else if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL_MKT) {
                        if (eachData["SL TRIGGER"] > 0)
                            nTriggerPrice = eachData["SL TRIGGER"];
                    }
                    else if (eachData["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL) {
                        if (eachData["SL LIMIT"] > 0) {
                            scripPrice = eachData["SL LIMIT"];
                        }
                        if (eachData["SL TRIGGER"] > 0) {
                            nTriggerPrice = eachData["SL TRIGGER"];
                        }
                    }
                    let DecimalLocator = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                    const nSelPriceTick = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                    if (scripPrice > 0) {
                        nScripPrice = scripPrice;
                        strPrice = 'price';
                        const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                        const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        if (PriceinPaise % parseInt(nSelPriceTick) != 0) {
                            bPriceValidation = true;
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs} ` }));
                            return false;
                        }
                    }
                    if (eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.OPT) || (eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.FUT))) {
                        if (parseInt(eachData["QTY"]) % parseInt(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]) !== 0) {
                            bQtyValidation = true;
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: MSG_MASTER.NNSL46 + eachData["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT] }));
                            return false;
                        }
                    }
                    if (nTriggerPrice > 0) {
                        nScripPrice = nTriggerPrice;
                        strPrice = 'trigger price';
                        const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                        const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        if (PriceinPaise % parseInt(nSelPriceTick) != 0) {
                            bPriceValidation = true;
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs}` }));
                            return false;
                        }
                    }
                });
                if (bPriceValidation || bQtyValidation) {
                    //  dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is  `}));
                    dispatch(setShowSideTrayPlaceOrder(true));
                    return false;
                }
                //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 10-05-2024 : To restrict scrip which price is not multiple of price tick - End
                else {
                    // validations for pre trade bse
                    if (!bsePreTradeMsgAccepted) {
                        const arrViolatingScrips = checkBsePreTradeValidation(arrOrderCartData);
                        if (arrViolatingScrips.length > 0) {
                            setBsePreTradeViolatingScrips(arrViolatingScrips);
                            // To keep showing order entry in sidetray if there are any scrips that have bse pre trade vilations
                            dispatch(setShowSideTrayPlaceOrder(true));
                            return false;
                        }
                    }
                    arrOrderCartData.forEach(eachHoldingScrip => {
                        if (eachHoldingScrip["PROD TYPE"].toUpperCase().includes(ORDER_PRODUCT_TYPES.DELIVERY) && eachHoldingScrip["BUY/SELL"] == "SELL") {
                            const objHoldingScrip = holdingsScrips?.find(eachScrip => eachScrip.ISIN === eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE]);
                            if (objHoldingScrip && Object.keys(objHoldingScrip).length > 0) {
                                if (eachHoldingScrip["QTY"] > parseInt(objHoldingScrip.TOTALFREEQUANTITY)) {
                                    bIsShortSellValidationFailed = true;
                                    arrHoldingFailedScrips.push(eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]);
                                }
                            }
                            else {
                                bIsShortSellValidationFailed = true;
                                arrHoldingFailedScrips.push(eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]);
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                            }
                        }
                        //BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 - Start
                        if (checkGSM == FACILITY_STR.ON && eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] != null) {
                            let objSurvMeasure = {
                                marketSegmentId: getApiExchangeNameFromMktSegId(eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                                token: eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                                cautionaryText: eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION],
                                textString: `${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]} <br>  Graded Surveillance Measure <br> ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`,
                                //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --Start
                                symbol: eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL] + '-' + eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                                buySell: eachHoldingScrip["BUY/SELL"] === ORDER_ENTRY_BUY_SELL_TEXT.BUY ? CAUTIONARY_TRANSACTION_TYPE.BUY : CAUTIONARY_TRANSACTION_TYPE.SELL,
                                //  Azeem K :08-08-2025 :BREEZE-9398  -Cautionary Message Pop-up Alert Logs - Enhancement - Breeze  --End
                            };
                            arrSurvMeasuresData.push(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]} Graded Surveillance Measure ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]}`);
                            let check = arrSurvMeasureData.some(eachWord => eachWord?.textString?.includes(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}`));
                            // if (!arrSurvMeasureData.some(eachWord.includes(`${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]} ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}`))) {
                            if (!check) {
                                setArrSurvMeasureData(curr => [...curr, objSurvMeasure]);
                            }
                        }
                    });
                    //BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 - End
                    if (bIsShortSellValidationFailed) {
                        dispatch(setShowSideTrayPlaceOrder(true));
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${arrHoldingFailedScrips.join(', ')}.Short selling is not allowed for Delivery ` }));

                    }
                    else if (arrSurvMeasuresData?.length > 0 || isSurvMeasure) {
                        setIsSurvMeasure(true);
                        dispatch(setShowSideTrayPlaceOrder(true));
                    }
                    else if (bannedScripsList?.length > 0) {
                        let arrBannedMessage = [];
                        bannedScripsList.forEach(eachScrip => {
                            if (eachScrip.nBanFlag == 1) {
                                arrBannedMessage.push({ name: eachScrip.sSymbol, expiry: eachScrip.nExpiryDate });
                            }
                        });
                        setIsBannedScrips(true);
                        dispatch(setShowSideTrayPlaceOrder(true));
                        dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': true }]));
                        dispatch(handleModalData({ data: { bannedMessage: arrBannedMessage } }));
                    }
                    else {
                        var arrOrderData = [];
                        if (arrOrderCartData?.length != 0) {
                            arrOrderCartData?.forEach((ele, i) => {
                                let strProdType = ele["PROD TYPE"] === objDefaultProductType?.sDescription ? objDefaultProductType?.sDefaultProductType : ele["PROD TYPE"];
                                let objData = {
                                    id: i + 1,
                                    buySellType: ele["BUY/SELL"],
                                    productType: strProdType,
                                    sDefaultProductType: objDefaultProductType?.sDefaultProductType,
                                    orderType: ele["ORDER TYPE"],
                                    validity: ele["VALIDITY"],
                                    exchange: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE],
                                    count: ele["QTY"],
                                    amo: ele["AMO"],
                                    slTrigger: ele["SL TRIGGER"],
                                    slLimit: ele["SL LIMIT"],
                                    price: ele["PRICE"],
                                    exchangeId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                                    token: ele["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                                    decimalLocator: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                                    decimalLocatorLength: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                                    symbol: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL],
                                    series: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                                    instrument: ele["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT],
                                    exchangeSegment: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                                    isinCode: ele["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE],
                                    securityDesc: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                                    expiryDate: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE],
                                    strikePrice: ele["SYMBOL"][WATCHLIST_GRID_INDEX.STRIKEPRICE],
                                    optionType: ele["SYMBOL"][WATCHLIST_GRID_INDEX.OPTIONTYPE],
                                    priceTick: ele["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],//BT-106965 : Ordercart : SAT2 Issues : ManasaB : 11-06-2024
                                    mappedSegId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                                    marketLot: ele["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT],// BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                                    maturityDate: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MATURITY_DATE],
                                    expiryInMilliSec: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRY_IN_MILLISEC],
                                    sSurvMeasureDescription: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION]
                                };
                                arrOrderData.push(objData);
                            });
                            if (layoutType == LAYOUT_TYPE.HORIZONTAL) {
                                dispatch(storeGridData(arrOrderCartData));
                                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, { 'ORDER_CART_NAME_MODAL': true }]), true);
                                dispatch(handleModalData({
                                    data: {
                                        orderCartInfo: arrOrderData,
                                        orderEntryTab: 'multi_scrip', activeTabKey: 'basket',
                                        method: strIdentifyOrderCartMethod,
                                        ordercartName: bObjSelectedCartRowData ? objModalData?.data?.method === 'clone' ? strCartName : (objSelectedCartRowData?.ordercartName) : strCartName,
                                        strOrderCartId: bObjSelectedCartRowData ? (objSelectedCartRowData?.ordercartId) : strCartId,
                                        isGoback: (objModalData?.data?.isGoback) ? objModalData?.data?.isGoback : false //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024
                                    }
                                }));
                                setStrCartName('');
                                dispatch(updateOrderCartRowData({}));
                                dispatch(convertToOrderCart(false));
                                setArrScripsToCheckBan([]);
                                dispatch(getBannedScripsListFailure([]));
                            }
                            else {
                                dispatch(getOrderDataBackupVertical([...arrScripsData]));
                                setBIsShowCreateCart(true);
                                dispatch(getOrderCartScrps(arrOrderData));
                            }
                            //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
                        }
                        else {
                            if (layoutType === LAYOUT_TYPE.VERTICAL) {
                                dispatch(setShowSideTrayPlaceOrder(true));
                            }
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Minimum one scrip is required in cart to place an order` }));
                        }
                        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To restrict scrips if exceeds count - End
                    }
                }
            }
            else {
                dispatch(setShowSideTrayPlaceOrder(true));
                dispatch((toastConfig({ autoDismiss: true, show: true, message: `You can not add more than ${nOrderCartCount} in single cart` })));
            }
        }
        //Suggested variables all are constants not required in dependency list
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [objSelectedCartRowData, strIdentifyOrderCartMethod, strCartName, arrSurvMeasureData, isSurvMeasure, arrScripsData, bannedScripsList, bsePreTradeMsgAccepted]);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 Security Measure - End
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    useImperativeHandle(ref, () => ({
        handleOpenOrderNameModal,
        saveCartData,
        handleMarginInfo
    }));
    useEffect(() => {
        if (bIsConfirmBack || bIsSaveCartBack) {
            setArrMarketPrice([...arrOrderCartMarketPriceData]);
            setArrScripsData(arrOrderBackupData);
            setBIsSaveCartBack(false);
        }
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [bIsConfirmBack, bIsSaveCartBack]);

    useEffect(() => {
        if (bsePreTradeViolatingScrips.length > 0) {
            dispatch(handleModal([{ "BSE_PRE_TRADE_WARNING_MODAL": true }]))
        }
    }, [bsePreTradeViolatingScrips, dispatch])

    useEffect(() => {
        if (bsePreTradeMsgAccepted) {
            dispatch(setShowSideTrayPlaceOrder(false));
            handleOpenOrderNameModal();
            setBsePreTradeMsgAccepted(false);
            setBsePreTradeViolatingScrips([]);
        }
    }, [bsePreTradeMsgAccepted, handleOpenOrderNameModal, dispatch]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.id;
        } else {
        }
    }, []);
    useEffect(() => {
        if (location.pathname === "/ordercart") {
            inputRef.current.focus();
        }
    }, [location]);

    //Ammersha changes -Start
    function divideArrayIntoGroups(array, groupSize) {
        let dividedArrays = [];
        let currentIndex = 0;

        while (currentIndex < array?.length) {
            let curentGroup = array?.slice(currentIndex, currentIndex + groupSize);
            dividedArrays?.push(curentGroup);
            currentIndex += groupSize;
        }
        return dividedArrays;
    }

    //Ameersha changes - ENd
    useEffect(() => {
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - Start
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            if (rowData?.length > 0) {
                const arrOrderInfo = [...rowData];
                if (arrOrderInfo.length > 0) {
                    calculatedAndGetOrderMarginInfoFor(arrOrderInfo);
                }
            }
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
        }
        //BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - End
        //Others not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [rowData]);
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - Start
    const handleAddScrips = () => {
        setBIsShowSearchScrip(true);
    };
    const handleEdit = (event, data) => {
        event.preventDefault();
        setBIsShowScripDetails(true);
        setObjSelectedScrip(data);
        dispatch(getExchangeWiseScripInfo(data?.SYMBOL));
        return () => {
            const arrDistinctScripExchangesSubscription = arrDistinctScripExchanges?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }));
            sendTouchlineRequest(arrDistinctScripExchangesSubscription);
        };

    };
    const handleHideScripDetails = () => {
        setBIsShowScripDetails(false);
        setObjSelectedScrip({});

    };
    const handleDropdown = (e, id) => {
        if (e.target.name === 'productType') {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "PROD TYPE": e.target.value } : each));
        }
        else if (e.target.name === 'orderType') {
            //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - Start
            if (e.target.value === ORDER_ENTRY_TYPES.SL || e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                setToggleStopLoss(true);
            }
            else {
                setToggleStopLoss(false);
            }
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "ORDER TYPE": e.target.value } : each));
            let objScripInfo = arrScripsData.find(eachData => eachData.id == id);
            if (e.target.value === ORDER_ENTRY_TYPES.SL_MKT) {
                let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                if (Number(objScripInfo['SL TRIGGER']) === 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
            }
            else if (e.target.value === ORDER_ENTRY_TYPES.SL) {
                let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                if (Number(objScripInfo["SL LIMIT"]) == 0 && Number(objScripInfo['SL TRIGGER']) == 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error', trigger: 'color-error' }));
                }
                else if (Number(objScripInfo['SL TRIGGER']) == 0 && Number(objScripInfo["SL LIMIT"]) != 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
                else if (Number(objScripInfo['SL TRIGGER']) != 0 && Number(objScripInfo["SL LIMIT"]) == 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                }
                else {
                    setBIsPlaceOrderBtnDisabled(false);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text', trigger: 'color-text' }));
                }
            }
            else {
                setBIsPlaceOrderBtnDisabled(false);
                if (e.target.value === ORDER_ENTRY_TYPES.RL) {
                    let nRange = objScripInfo["Range"];
                    let minRange = nRange.split('-')[0];
                    let maxRange = nRange.split('-')[1];
                    if ((parseFloat(objScripInfo["PRICE"]) < parseFloat(minRange)) || (parseFloat(objScripInfo["PRICE"]) > parseFloat(maxRange))) {
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                    }
                }
                else if (e.target.value === ORDER_ENTRY_TYPES.RL_MKT) {
                    let objMarketPrice = arrMarketPrice.find(eachData => eachData.id == id);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: objMarketPrice?.price } : each));
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                }
                else {
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                }
            }
            //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End
        }
        else if (e.target.name === 'validity') {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "VALIDITY": e.target.value } : each));
        }

    };
    useEffect(() => {
        if (layoutType == LAYOUT_TYPE.VERTICAL && arrScripsData?.length > 0) {
            let arrScripsInfo = [...arrScripsData];
            for (let i = 0; i < arrScripsInfo?.length; i++) {
                let arrRange = arrScripsInfo[i]["Range"] != '0.00-0.00' ? arrScripsInfo[i]["Range"]?.split("-") : [];
                let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
                let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
                if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL_MKT) {
                    if (Number(arrScripsInfo[i]["SL TRIGGER"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(arrScripsInfo[i]["SL TRIGGER"]) < parseFloat(minRange)) || (parseFloat(arrScripsInfo[i]["SL TRIGGER"]) > parseFloat(maxRange))) {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
                else if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.SL) {

                    if (Number(arrScripsInfo[i]["SL LIMIT"]) == 0 && Number(arrScripsInfo[i]['SL TRIGGER']) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error', trigger: 'color-error' }));
                    }
                    else if (Number(arrScripsInfo[i]['SL TRIGGER']) == 0 && Number(arrScripsInfo[i]["SL LIMIT"]) != 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else if (Number(arrScripsInfo[i]['SL TRIGGER']) != 0 && Number(arrScripsInfo[i]["SL LIMIT"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(arrScripsInfo[i]["SL LIMIT"]) < parseFloat(minRange)) || (parseFloat(arrScripsInfo[i]["SL LIMIT"]) > parseFloat(maxRange))) {
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        }
                        if ((parseFloat(arrScripsInfo[i]["SL TRIGGER"]) < parseFloat(minRange)) || (parseFloat(arrScripsInfo[i]["SL TRIGGER"]) > parseFloat(maxRange))) {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
                else if (arrScripsInfo[i]["ORDER TYPE"] === ORDER_ENTRY_TYPES.RL) {
                    if (Number(arrScripsInfo[i]["PRICE"]) == 0) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {

                        setBIsPlaceOrderBtnDisabled(false);
                        if ((parseFloat(arrScripsInfo[i]["PRICE"]) < parseFloat(minRange)) || (parseFloat(arrScripsInfo[i]["PRICE"]) > parseFloat(maxRange))) {
                            setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                        }
                        else {
                            setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                        }
                    }
                }
                else {
                    setBIsPlaceOrderBtnDisabled(false);
                }
            }
        }
        //setBIsPlaceOrderBtnDisabled not required
        // eslint-disable-next-line reactHooks/exhaustive-deps
    }, [arrScripsData, activeTabKey, multiScripOrderActiveTabKey, layoutType]);
    //Quantity
    const handleQuantity = (e, id) => {
        if (parseInt(e.target.value) <= 0) {
            setBIsPlaceOrderBtnDisabled(true);
        } else if (!e?.target?.value?.includes('.') && e.target.value < 99999999)
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: e.target.value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleQuantityIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = parseInt(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]);
        switch (name) {
            case "subQuantity":
                if (objScripInfo["QTY"] > nIncrementValue) {
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: each["QTY"] - nIncrementValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addQuantity":
                if (objScripInfo["QTY"] < 99999999) {
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, QTY: each["QTY"] + nIncrementValue } : each));
                    break;
                }
            default:
        }
    };

    //Price
    const handlePrice = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handlePriceIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subPrice":
                if (objScripInfo["PRICE"] > 0) {
                    let updatedValue = (parseFloat(objScripInfo["PRICE"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addPrice":
                if (objScripInfo["PRICE"].length <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(props.data["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["PRICE"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, PRICE: updatedValue } : each));
                    break;
                }
            default:
        }
    };

    const handlePriceBlur = (e, id) => {
        e.preventDefault();
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["PRICE"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
            }
            else {
                if (!objScripInfo["PRICE"]?.toString()?.includes('.')) {
                    objScripInfo["PRICE"] = parseFloat(objScripInfo["PRICE"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(objScripInfo["PRICE"]) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                }
                else {
                    if (parseFloat(objScripInfo["PRICE"]) > maxRange || parseFloat(objScripInfo["PRICE"]) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-error' }));
                    }
                    else {
                        setBIsPlaceOrderBtnDisabled(false);
                        setObjRangeColor(prevData => ({ ...prevData, price: 'color-text' }));
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    };
    //SLTRIGGER
    const handleSLTrigger = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id === id ? { ...each, "SL TRIGGER": value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleSLTriggerIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subSLTrigger":
                if (objScripInfo["SL TRIGGER"] > 0) {
                    let updatedValue = (parseFloat(objScripInfo["SL TRIGGER"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addSLTrigger":
                if (objScripInfo["SL TRIGGER"] <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["SL TRIGGER"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": updatedValue } : each));
                    break;
                }
            default:
        }
    };
    const handleTriggerFocus = useCallback((id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        if (parseFloat(objScripInfo["SL TRIGGER"]) == 0) {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": '' } : each));
        }
    }, [arrScripsData]);
    const handleTriggerBlur = (id) => {
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["SL TRIGGER"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL TRIGGER": '0.00' } : each));
                setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
            }
            else {
                if (!objScripInfo["SL TRIGGER"]?.toString()?.includes('.')) {
                    objScripInfo["SL TRIGGER"] = parseFloat(objScripInfo["SL TRIGGER"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(objScripInfo["SL TRIGGER"]) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                }
                else {
                    if (parseFloat(objScripInfo["SL TRIGGER"]) > maxRange || parseFloat(objScripInfo["SL TRIGGER"]) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        if (objScripInfo["ORDER TYPE"] == 'SL') {
                            if (parseFloat(objScripInfo["SL LIMIT"]) == 0) {
                                setBIsPlaceOrderBtnDisabled(true);
                            }
                            else {
                                setBIsPlaceOrderBtnDisabled(false);
                                setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                            }
                        }
                        else {
                            setBIsPlaceOrderBtnDisabled(false);
                            setObjRangeColor(prevData => ({ ...prevData, trigger: 'color-text' }));
                        }
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    };
    //SLLMIT
    const handleLimitFocus = useCallback((id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        if (parseFloat(objScripInfo["SL LIMIT"]) == 0) {
            setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": '' } : each));
        }
    }, [arrScripsData]);
    const handleSLLimit = (e, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let { value } = e.target;
        value = value?.replace(/[^0-9.]/g, '');
        let decimalCount = value?.split('.').length - 1;
        if (decimalCount > 1) {
            value = value.slice(0, value.lastIndexOf('.'));
        }
        let valueParts = value.split('.');
        if (valueParts[1] && valueParts[1].length > objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) {
            value = `${valueParts[0]}.${valueParts[1].slice(0, 2)}`;
        }
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": value } : each));
        setBIsPlaceOrderBtnDisabled(false);
    };
    const handleSLLimitIncDec = (name, id) => {
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let nIncrementValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK];
        switch (name) {
            case "subSLLimit":
                if (Number(objScripInfo["SL LIMIT"]) > 0) {
                    let updatedValue = (parseFloat(objScripInfo["SL LIMIT"]) - nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                    setBIsPlaceOrderBtnDisabled(false);
                } else { };
                break;
            case "addSLLimit":
                if (Number(objScripInfo["SL LIMIT"]) <= 0) {
                    let updatedValue = objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK].toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                }
                else {
                    let updatedValue = (parseFloat(objScripInfo["SL LIMIT"]) + nIncrementValue).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": updatedValue } : each));
                    break;
                }
            default:
        }
    };

    const handleLimitBlur = (id) => {
        setArrScripsData(prevArray => {
            let objScripInfo = prevArray.find(each => each.id == id);
            let arrRange = objScripInfo["Range"] != '0.00-0.00' ? objScripInfo["Range"]?.split("-") : [];
            let minRange = arrRange?.length > 0 ? parseFloat(arrRange[0]) : 0;
            let maxRange = arrRange?.length > 0 ? parseFloat(arrRange[1]) : 0;
            if (objScripInfo["SL LIMIT"] == '') {
                setBIsPlaceOrderBtnDisabled(true);
                setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "SL LIMIT": '0.00' } : each));
            }
            else {
                if (!objScripInfo["SL LIMIT"]?.toString()?.includes('.')) {
                    objScripInfo["SL LIMIT"] = parseFloat(objScripInfo["SL LIMIT"]).toFixed(objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }

                if (parseFloat(objScripInfo["SL LIMIT"]) <= 0) {
                    setBIsPlaceOrderBtnDisabled(true);
                    setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                }
                else {
                    if (parseFloat(objScripInfo["SL LIMIT"]) > maxRange || parseFloat(objScripInfo["SL LIMIT"]) < minRange) {
                        setBIsPlaceOrderBtnDisabled(true);
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-error' }));
                    }
                    else {
                        setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        if (objScripInfo["ORDER TYPE"] == 'SL') {
                            if (parseFloat(objScripInfo["SL TRIGGER"]) == 0) {
                                setBIsPlaceOrderBtnDisabled(true);
                            }
                            else {
                                setBIsPlaceOrderBtnDisabled(false);
                                setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                            }
                        }
                        else {
                            setBIsPlaceOrderBtnDisabled(false);
                            setObjRangeColor(prevData => ({ ...prevData, limit: 'color-text' }));
                        }
                    }
                }
            }
            const newArray = prevArray.map(each => each.id === id ? { ...each, objScripInfo } : each);
            return newArray;
        });
    };
    const handleAMO = (e, id) => {
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "AMO": e.target.checked, amoUpdated: true } : each));
    };
    const handleToggling = (e, id) => {
        const { value } = e.target;
        setArrScripsData(prevItem => prevItem.map(each => each.id == id ? { ...each, "ActiveButtonToggleIndex": value == 'BUY' ? 0 : 1, "BUY/SELL": value, "BtnColor": value == 'BUY' ? 'color-positive' : 'color-negative' } : each));
    };
    const onClickStopLoss = () => {
        setToggleStopLoss(prevState => !prevState);
    };
    const onExchangeChange = async (strExchange, id) => {
        let arrMarketPriceList = [];
        let objScripInfo = arrScripsData.find(each => each.id == id);
        let arrUpdatedOrderData = [...arrScripsData];
        let mktSegId = getMktSegIdFromApiExchangeName(`${strExchange}_EQ`);
        let exchange = getApiExchangeNameFromMktSegId(mktSegId);
        let data = await getOptionChainData({
            instrumentName: SCRIP_INSTRUMENTS.EQUITIES, symbol: objScripInfo["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL], allowedId: objLoginSession.nExchangesViewAllowed
        });
        const arrWithIndex = getSearchDataAsPerSearchIndexes(data, true);
        let arrFilteredData = arrWithIndex.find(eachData => eachData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] == exchange);
        let nIndex = arrUpdatedOrderData.findIndex(eachData => eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] == arrFilteredData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (nIndex < 0) {
            sendTouchlineRequest([
                { exchangeId: arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID]?.length != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] : 0, token: arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN]?.length != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX?.TOKEN] : 0 },
            ]);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let arrLastTick = objLastTickData[arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                let nRange = arrLastTick != undefined ? arrLastTick[TL_INDEX.DAILY_PRICE_RANGE] : '0.00 - 0.00';
                let price = arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00';
                let objMarketPrice = {
                    id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${objScripInfo["BUY/SELL"]}`,
                    price
                };
                arrMarketPriceList.push(objMarketPrice);
                setArrScripsData(prevArray => {
                    const arrPrevData = [...prevArray];
                    const newObj = {
                        id: `${arrFilteredData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}_${objScripInfo["BUY/SELL"]}`,
                        'BUY/SELL': objScripInfo["BUY/SELL"], 'SYMBOL': arrFilteredData,
                        'EXCHANGE': arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE],
                        "ORDER TYPE": "RL-MKT",
                        "VALIDITY": arrFilteredData[WATCHLIST_GRID_INDEX.EXCHANGE] == 'NSE' ? "DAY" : 'EOSESS',
                        "QTY": arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1,
                        "PRICE": arrLastTick?.length > 0 ? arrLastTick[TL_INDEX?.LAST_TRADE_PRICE] : '0.00',
                        "PROD TYPE": arrFilteredData[WATCHLIST_GRID_INDEX.INSTRUMENT] == SCRIP_INSTRUMENTS.EQUITIES ? objDefaultProductType.sDescription : objDefaultDerivativeProductType.sDescription,
                        "SL LIMIT": '0.00',
                        "SL TRIGGER": '0.00',
                        "AMO": false, "BtnColor": objScripInfo["BUY/SELL"] == 'BUY' ? 'color-positive' : 'color-negative',
                        "Range": parseFloat(arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE]) != 0 ? arrFilteredData[WATCHLIST_GRID_INDEX.DAILY_PRICE_RANGE] : nRange,
                        "ActiveButtonToggleIndex": 0,
                        "amoUpdated": false
                    };
                    const arrUpdatedPrevData = arrPrevData.map(each => each.id === id ? { ...each, ...newObj } : each);
                    setObjSelectedScrip(newObj);
                    setArrMarketPrice(arrMarketPriceList);
                    dispatch(getOrderMarketPriceList(arrMarketPriceList));
                    return arrUpdatedPrevData;
                });
            }, 200);
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
        }

        else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Selected exchange scrip is already exist in ordercart. Please choose other exchange and try again.` }));
        }
    };
    const onhandleMarketDepth = (arrActiveScripInformation, field) => {
        setStrMarketDepthField(field);
        setIsShowMarketDepth(curr => {
            if (!curr && props?.data?.SYMBOL?.length) {
                dispatch(getExchangeWiseScripInfo(props?.data?.SYMBOL));
            }
            return !curr;
        });
        if (arrActiveScripInformation?.length != 0) {
            const resitancePivotObj = calculateSupportRestistanceValues(arrActiveScripInformation, 'Classic', '(H+L+C)/3');
            setSupportResistance(resitancePivotObj);
        } else { }
    };
    const handleDelete = (id) => {
        setArrScripsData(prevItem => prevItem.filter(each => each.id != id));
    };
    //BT-106965 : Order Cart : Side Tray : ManasaB : 23-07-2024 - End
    let strScripCountExceedColor = layoutType == LAYOUT_TYPE.HORIZONTAL ? rowData?.length > nOrderCartCount ? 'font-medium font-size2 color-error' : 'font-regular font-size1 color-text' : arrScripsData?.length > nOrderCartCount ? 'font-medium font-size2 color-error' : 'font-regular font-size1 color-text';
    useEffect(() => {
        const arrOrderData = [...arrScripsData];
        if (arrOrderData.length > 0) {
            dispatch(getOrderDataBackupVertical([...arrOrderData]));
        }
    }, [arrScripsData, dispatch]);
    //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues - End

    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);

    const rowSelection = useMemo(() => {
        return {
            mode: GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            checkboxes: true
        };
    }, []);

    const handleCellValueChange = (params) => {
        // const arrUpdatedRowData = params.api.getRenderedNodes().map((n) => ({ ...n.data }));
        // setRowData(arrUpdatedRowData);
        let arrUpdatedRowData = [...rowData]
        const noRows = arrUpdatedRowData?.length === 0;
        const hasInvalidOrder = arrUpdatedRowData.some((row) => {
            const orderType = row["ORDER TYPE"];
            const price = parseFloat(row["PRICE"]) || 0;
            const slTrigger = parseFloat(row["SL TRIGGER"]) || 0;
            const slLimit = parseFloat(row["SL LIMIT"]) || 0;
            const inValidRL = orderType === "RL" && (!isFinite(price) || price <= 0);
            const inValidSLT = orderType === ORDER_ENTRY_TYPES.SL_MKT && (!isFinite(slTrigger) || slTrigger <= 0);
            const invalidSLL = orderType === ORDER_ENTRY_TYPES.SL && ((!isFinite(slLimit) || slLimit <= 0) || (!isFinite(slTrigger) || slTrigger <= 0));
            return inValidRL || inValidSLT || invalidSLL;
        });
        setBDisableSaveBtn(hasInvalidOrder || noRows);

    };
    return (
        <>
            {/* BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - Start */}
            <BrokerageModalMultiLeg sentFrom='ordercart' />
            {/* BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - End */}
            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measure - Start */}
            {isSurvMeasure && <SurvMeasureModal arrSurvData={arrSurvMeasureData} setIsSurvMeasure={setIsSurvMeasure} isSurvMeasure={isSurvMeasure} setArrSurvMeasureData={setArrSurvMeasureData} />}
            {isBannedScrips && <BannedScripModal setBIsBannedScripAccepted={setBIsBannedScripAccepted} setBIsBannedScripRejected={setBIsBannedScripRejected} />}
            {bsePreTradeViolatingScrips.length > 0 ? <PreTradeFailedScripsModal pretradeValidationFailedScrips={bsePreTradeViolatingScrips} setBsePreTradeViolatingScrips={setBsePreTradeViolatingScrips} setBsePreTradeMsgAccepted={setBsePreTradeMsgAccepted} /> : null}
            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 18-04-2024 : Security Measure - End */}
            {layoutType === LAYOUT_TYPE.HORIZONTAL ?
                <>
                    <Container fluid className='p-0 order-cart-wrap'>
                        <Row className='g-0 my-3'>
                            <Col md={12}>
                                <BzMasterAgGrid
                                    testId='order-cart-grid'
                                    gridKey={'Basket'}
                                    selectionColumnDef={selectionColumnDef}
                                    rowSelection={rowSelection}
                                    rowHeight={70}
                                    className='ag-theme-alpine multiscrip-ordercart-ag-grid-wrapper'
                                    ref={MULTISCRIP_ORDER_CART_GRID_REF}
                                    getRowId={getRowId}
                                    arrRowData={rowData}
                                    rowBuffer={1}
                                    arrColumnData={columnDefs}
                                    isShowEmptyGrid={true}
                                    onCellValueChanged={(params) => handleCellValueChange(params)}
                                />
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col>
                                <div data-testid="ordercart-search-wrapper" className='oe-horizontal-search-wrapper'>
                                    <Row className='g-0 align-items-center'>
                                        <div data-testid="ordercart-search-container" className='oe-modal-scrip-search-wrap'>
                                            <Row className='g-0 justify-content-between align-items-center'>
                                                <Col>
                                                    <div data-testid="ordercart-search-input-wrapper" className='position-relative'>
                                                        <div data-testid="ordercart-search-icon" className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                        <BzInputText data-testid="ordercart-search-input" ref={inputRef} size='sm' className='font-regular text-uppercase scripname-searchtext p-l-30' type='search' name="search" placeholder='Search scrips to add above' value={strSearchInputText}
                                                            onChange={(e) => onChangeTabSearch(e)} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start  */}
                                        <Col className='text-end'>
                                            <div data-testid="ordercart-scrip-count" className='font-medium font-size2 color-text'>Scrip Count : <span className={`${strScripCountExceedColor}`}>{rowData?.length}</span>/<span className='font-regular font-size1 color-text'>{nOrderCartCount}</span> </div>
                                        </Col>
                                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End  */}
                                    </Row>
                                    {orderBookSearchModal ?
                                        <div className='oe-search-wrap'>
                                            <div className='oe-search-content'>
                                                <TabsScripsList isKeyboard={false} arrGlobalScripts={arrGlobalScripts} showDefault isActive setAddToggle={setAddToggle}
                                                    strSearchInputText={strSearchInputText} orderBookSearchModal={orderBookSearchModal} setStrSearchInputText={setStrSearchInputText}
                                                    scripDetails={isFlag ? globalScripDetails : arrSymbolData}
                                                    setOrderBookSearchModal={setOrderBookSearchModal} isDefaultAllTab={true}
                                                    onBuySellClick={onBuySellClick} checkBuyExisting={checkBuyExisting}
                                                    checkSellExisting={checkSellExisting} />
                                            </div>
                                        </div>
                                        : ""}
                                </div>
                            </Col>
                            {/* ManasaB : 29/02/2024 : Commenting View Brokerage and charges as work is still in progress from backend - Start*/}
                            {/* <Col className='d-flex flex-column align-items-end'>
                                <BzButton className='btn btn-md btn-outline d-flex align-items-center text-capitalize'>
                                    <span>Upload Excel</span>
                                    <div className='icon-16 icon-upload icon-primary ms-2'></div>
                                </BzButton>
                                <a href='#' className='font-medium font-size1 color-primary text-center me-2 mt-2'>Download Sample</a>
                            </Col> */}
                            {/* ManasaB : 29/02/2024 : Commenting View Brokerage and charges as work is still in progress from backend - End*/}
                        </Row>

                        <Row data-testid="ordercart-margins-row" className='g-0 py-2 bdr-top'>
                            <Col data-testid="ordercart-margins-left" md={6} className='d-flex justify-content-start align-items-center'>
                                <div data-testid="ordercart-approx-margin-container" className='d-flex flex-column justify-content-start pe-4'>
                                    <div data-testid="ordercart-approx-margin-label" className='font-regular font-size1 color-text'>Approx. Margin</div>
                                    {
                                        isLoadingMarginInfo ?
                                            <BzDotsLoader data-testid="ordercart-approx-margin-loader" />
                                            :
                                            rowData?.length > 0 && <div data-testid="ordercart-approx-margin-value" className='font-medium font-size1 color-text'>{parseFloat(totalMargin) ? convertNumberWithCommasForCurrency(parseFloat(totalMargin), true) : totalMargin}</div>
                                    }
                                </div>
                                <div data-testid="ordercart-available-margin-container" className='d-flex flex-column justify-content-start pe-4'>
                                    <div data-testid="ordercart-available-margin-label" className='font-regular font-size1 color-text'>Available Margin</div>
                                    {

                                        isLoadingMarginInfo ?
                                            <BzDotsLoader data-testid="ordercart-available-margin-loader" />
                                            :
                                            rowData?.length > 0 && <div data-testid="ordercart-available-margin-value" className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin}</div>
                                    }
                                </div>
                                <div data-testid="ordercart-refresh-icon" className='d-flex align-items-center pe-4 cursor-pointer focus' onClick={() => calculatedAndGetOrderMarginInfoFor([...rowData])}>
                                    <div className='icon-12 icon-refresh background-textual-link-withicon'></div>
                                    <div className='font-medium font-size1 color-textual-link-withicon ms-2'>Update</div>
                                </div>
                            </Col>
                            <Col data-testid="ordercart-save-btn-container" md={6} className='d-flex justify-content-end align-items-center'>
                                <BzButton data-testid="ordercart-saveplaceorder-button" disabled={bDisableSaveBtn} className='btn btn-md btn-primary text-capitalize' onClick={handleOpenOrderNameModal}>SAVE CART &amp; PLACE ORDEsR</BzButton>
                            </Col>
                        </Row>
                        {
                            isShowMarketDepth &&
                            <Row className='bdr-top px-2 py-3 mt-3'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='submenu-wrapper d-flex align-items-center'>
                                                <div onClick={() => setMarketDepthActiveTab('MarketDepth')} className={`submenuItem ${marketDepthActiveTab == 'MarketDepth' ? 'active' : ''}`}>Market Depth</div>
                                                <div onClick={() => setMarketDepthActiveTab('supportResistance')}
                                                    className={`submenuItem ${marketDepthActiveTab == 'supportResistance' ? 'active' : ''}`}>Support/Resistance</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                                <div>
                                    {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth onValueClick={onValueClick} heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance onValueClick={onValueClick} supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={LAYOUT_TYPE.HORIZONTAL} /> : null}
                                </div>
                            </Row>
                        }
                    </Container>
                </>
                : (
                    layoutType === LAYOUT_TYPE.VERTICAL ?
                        // ManasaB:07-10-14 : UI changes taken from release branch - Start
                        <>
                            <div className='font-medium font-size2 color-text px-3'>Scrip Count: <span className={`${strScripCountExceedColor}`}>{arrScripsData?.length}</span> / <span className='font-regular font-size1 color-text'>{nOrderCartCount}</span></div>
                            <div className='sticky-orderticket-ordercart'>
                                <Container fluid className='p-0 pb-3 px-3'>
                                    {
                                        arrScripsData && arrScripsData.length > 0 && arrScripsData?.map(eachData => {

                                            return <>
                                                <div id={eachData?.id} className='ordercart-card p-3 my-3'>
                                                    <Row className="g-0">
                                                        <Col>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='font-medium font-size3 color-text'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                                {eachData["ISBANNED"] &&
                                                                    <>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='chips-wrap ms-2'>
                                                                                <div className='banned-chip'>Banned</div>
                                                                            </div>

                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className='d-flex align-items-center flex-wrap my-2'>
                                                                <div className='chips-wrap'>
                                                                    <div className='exchange-chip text-uppercase'>{eachData["EXCHANGE"]}</div>
                                                                </div>
                                                                <div className='font-medium font-size1 color-subtext text-capitalize'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                                <div className='font-regular font-size1 color-subtext ms-1'>
                                                                    {eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE] !== 'NA' ?
                                                                        <span className='font-regular font-size1 color-subtext'>
                                                                            {eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT]?.indexOf(SCRIP_INSTRUMENTS.FUT) === 0 ? <span className='font-regular font-size1 color-subtext'>{`${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(0, 2)} ${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(2, 5).charAt(0)}${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(2, 5).slice(1, 3).toLowerCase()} ${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(5, 9)} `} </span> : <span className='font-regular font-size1 color-subtext'>{`${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(0, 2)} ${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(2, 5).charAt(0)}${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.EXPIRYDATE]?.slice(2, 5).slice(1, 3).toLowerCase()} ${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${eachData["SYMBOL"][WATCHLIST_GRID_INDEX.OPTIONTYPE]}`}</span>}</span> : ''}</div>
                                                            </div>
                                                            <div className={`font-medium font-size3 ${eachData["BtnColor"]}`}>{eachData["BUY/SELL"]}<span className='font-regular color-text ms-1'>@ &#8377;{eachData["PRICE"]}</span></div>
                                                        </Col>
                                                        {(bIsShowScripDetails && Object.keys(objSelectedScrip.length > 0) && objSelectedScrip.id == eachData["id"]) ?
                                                            <div className='icon-16 icon-arrowup icon-dark ms-3' onClick={(event) => handleHideScripDetails(event, eachData)}></div>
                                                            : <> <Col md={4} className='d-flex flex-column align-items-end'>
                                                                <div className='d-flex align-tems-center'>
                                                                    {/* BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - Start */}
                                                                    {arrScripsData.length != 1 && <div className='icon-16 icon-delete icon-dark me-2 mb-3 flex-shrink-0' onClick={handleDelete.bind(this, eachData.id)}></div>}
                                                                    {/* BREEZE-305 : ManasaB : 16-10-2024 : Watchlist Side tray- Order Cart Order entry - End */}
                                                                    <div className='icon-16 icon-edit icon-dark ms-2 mb-3 flex-shrink-0' onClick={(event) => handleEdit(event, eachData)}></div>
                                                                </div>
                                                                <div className='input-group postion-relative'>
                                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleQuantityIncDec.bind(this, "subQuantity", eachData.id)}></div>
                                                                    <BzInputText size='sm' type='text' className='font-regular text-center' value={eachData["QTY"]} onChange={(e) => handleQuantity(e, eachData.id)} />
                                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={handleQuantityIncDec.bind(this, "addQuantity", eachData.id)}></div>
                                                                </div>
                                                                {(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.OPT) || (eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.FUT))) && <div className='font-medium font-size1 color-subtext range-container mt-1'>(1Lot = <span className='color-text'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]}Qty</span>)</div>}
                                                            </Col></>}
                                                    </Row>
                                                    {
                                                        (bIsShowScripDetails && objSelectedScrip["id"] == eachData["id"]) ?
                                                            <>
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex justify-content-end'>
                                                                        <BzToggleButton
                                                                            wrapperClassName='buysell-wrap'
                                                                            leftButtonClassName={`btn btn-sm ${eachData["ActiveButtonToggleIndex"] === 0 ? 'btn-positive' : ''}`}
                                                                            rightButtonClassName={`btn btn-sm ${eachData["ActiveButtonToggleIndex"] === 1 ? 'btn-negative' : ''}`}
                                                                            leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={eachData["ActiveButtonToggleIndex"]} setActiveButtonToggleIndex={(e) => handleToggling({ target: { name: "activeButtonToggleIndex", value: e === 0 ? "BUY" : "SELL" }, }, eachData.id)} />
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex align-items-center horizontal-scroll-wrap pb-1'>
                                                                        <div className='exch-radiochip-wrap ms-auto'>
                                                                            {/* ManasaB :23-11-2024 : Added loop for exchanges after discussion with Ajitesh and Sumit - Start */}
                                                                            {arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((eachExchange) => {
                                                                                return (
                                                                                    <BzChip onClick={() => onExchangeChange(eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE], eachData.id)} className={`radio-chip ms-2 ${eachData["EXCHANGE"] === eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE] && eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID] === eachExchange[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>
                                                                                        <div className={`exch-namechip ${eachData["EXCHANGE"] === eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE] && eachData["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID] === eachExchange[WATCHLIST_GRID_INDEX.SEGMENT_ID] ? 'active' : ''}`}>{eachExchange[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                                        <div className='font-regular font-size1 color-text text-end'>{eachData["BUY/SELL"] == "BUY" ? eachExchange[WATCHLIST_GRID_INDEX.ASK_PRICE] : eachExchange[WATCHLIST_GRID_INDEX.BID_PRICE]}</div>
                                                                                        <div className='font-regular font-size1 color-subtext text-end'>QTY: {eachData["BUY/SELL"] == "BUY" ? eachExchange[WATCHLIST_GRID_INDEX.ASK_QTY] : eachExchange[WATCHLIST_GRID_INDEX.BID_QUANTITY]}</div>
                                                                                    </BzChip>
                                                                                );
                                                                            })}
                                                                            {/* ManasaB :23-11-2024 : Added loop for exchanges after discussion with Ajitesh and Sumit - End */}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3'>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Product Type</div>
                                                                        {/* Breeze:6672 : Side tray Order Cart Derivatives : ManasaB : 27-05-2025 : Change product type based on the instrument -- LLD - Start */}
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["PROD TYPE"]?.length > 10 ? `${eachData["PROD TYPE"].slice(0, 10)}...` : eachData["PROD TYPE"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ?
                                                                                        arrProdTypes?.length > 0 && arrProdTypes?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={() => handleDropdown({ target: { value: eachOption?.sDescription, name: 'productType' } }, eachData.id)}>{eachOption?.sDescription}</Dropdown.Item>
                                                                                        )) : arrDervProductTypes?.length > 0 && arrDervProductTypes?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={() => handleDropdown({ target: { value: eachOption?.sDescription, name: 'productType' } }, eachData.id)}>{eachOption?.sDescription}</Dropdown.Item>
                                                                                        ))}
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                        {/* Breeze:6672 : Side tray Order Cart Derivatives : ManasaB : 27-05-2025 : Change product type based on the instrument -- LLD - End */}
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Order Type</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["ORDER TYPE"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {objDropdownOptions.orderType?.length > 0 && objDropdownOptions.orderType?.map((eachOption, i) => (
                                                                                        <Dropdown.Item key={i} onClick={() => handleDropdown({ target: { value: eachOption, name: 'orderType' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                    ))}
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3'>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='d-flex align-items-center mb-1'>
                                                                            <div className='font-regular font-size3 color-subtext'>Quantity</div>
                                                                        </div>
                                                                        <div className='input-group postion-relative'>
                                                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleQuantityIncDec.bind(this, "subQuantity", eachData.id)}></div>
                                                                            <BzInputText size='sm' type='number' className='font-regular text-center' value={eachData["QTY"]} onChange={(e) => handleQuantity(e, eachData.id)} />
                                                                            {/* Breeze:6672 : Side tray Order Cart Derivatives : ManasaB : 27-05-2025 : For derivatives show lot information also -- LLD  */}
                                                                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={handleQuantityIncDec.bind(this, "addQuantity", eachData.id)}></div>
                                                                        </div>
                                                                        {(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.OPT) || (eachData["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT].includes(SCRIP_INSTRUMENTS.FUT))) && <div className='font-medium font-size1 color-subtext range-container mt-1'>(1Lot = <span className='color-text'>{eachData["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]}Qty</span>)</div>}
                                                                    </Col>
                                                                    <Col md={6} className='flex-column align-items-start'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                                            <div className='font-regular font-size3 color-subtext'>Price</div>
                                                                            <div className='icon-20 icon-marketdepth ms-3' onClick={() => onhandleMarketDepth(eachData["SYMBOL"], 'price')}></div>
                                                                        </div>
                                                                        <div className='input-group postion-relative'>
                                                                            <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["RL"].includes(eachData["ORDER TYPE"])) && 'div-disabled'}`} onClick={handlePriceIncDec.bind(this, "subPrice", eachData.id)} ></div>
                                                                            <BzInputText size='sm' type='number' className='font-regular text-center' value={eachData["PRICE"]} onChange={(e) => handlePrice(e, eachData.id)} onBlur={(e) => handlePriceBlur(e, eachData.id)} disabled={!(["RL"].includes(eachData["ORDER TYPE"]))} />
                                                                            <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["RL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handlePriceIncDec.bind(this, "addPrice", eachData.id)} ></div>
                                                                        </div>
                                                                        <div className='d-flex align-items-center mt-2'>
                                                                            <BzToolTip placement='left' TooltipMsg='You can place your order within this price range.It is rectified by the exchanges or the nature of trading you are placing.'>
                                                                                <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                            </BzToolTip>
                                                                            <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size1 color-text ${objRangeColor.price}`}>{eachData["Range"]}</span></div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-3 align-items-center'>
                                                                    <Col md='auto'>
                                                                        <div className='d-flex align-items-center focus'>
                                                                            <div className='font-medium font-size3 color-text cursor-pointer' onClick={onClickStopLoss.bind(this)} >
                                                                                {'STOP LOSS'}
                                                                            </div>
                                                                            <div className='d-flex align-items-start cursor-pointer' onClick={onClickStopLoss.bind(this)}>{toggleStopLoss ? <div className='icon-16 icon-minus-circle-fill icon-dark ms-2'> </div> : <div className='icon-16 icon-add-circle-fill icon-dark ms-2'></div>}</div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {toggleStopLoss && eachData["ORDER TYPE"] != ORDER_ENTRY_TYPES.RL ?
                                                                    <Row className='mb-3'>
                                                                        <Col md={6} className='flex-column align-items-start'>
                                                                            <div className='d-flex align-items-center mb-1'>
                                                                                <div className='font-regular font-size3 color-subtext'>SL Trigger</div>
                                                                                <div className='icon-20 icon-marketdepth ms-3' onClick={() => onhandleMarketDepth(eachData["SYMBOL"], 'slTrigger')}></div>
                                                                            </div>
                                                                            <div className='input-group postion-relative'>
                                                                                <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLTriggerIncDec.bind(this, "subSLTrigger", eachData.id)}></div>
                                                                                <BzInputText size='sm' type='number' className='font-regular text-center' onFocus={() => handleTriggerFocus(eachData.id)} value={eachData["SL TRIGGER"]} onChange={(e) => handleSLTrigger(e, eachData.id)} onBlur={handleTriggerBlur.bind(this, eachData.id)} disabled={!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"]))} />
                                                                                <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["SL-MKT", "SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLTriggerIncDec.bind(this, "addSLTrigger", eachData.id)}></div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center mt-2'>
                                                                                <BzToolTip placement='left' TooltipMsg='Your order will be executed at available SL limit price when Trigger price is reached.'>
                                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                                </BzToolTip>
                                                                                <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size2 ${objRangeColor.trigger}`}>{eachData["Range"]}</span></div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col md={6} className='flex-column align-items-start'>
                                                                            <div className='d-flex align-items-center mb-1'>
                                                                                <div className='font-regular font-size3 color-subtext'>SL Limit</div>
                                                                                <div className='icon-20 icon-marketdepth ms-3' onClick={() => onhandleMarketDepth(eachData["SYMBOL"], 'slLimit')}></div>
                                                                            </div>
                                                                            <div className='input-group postion-relative'>
                                                                                <div className={`icon-12 icon-order-decrease input-number-left-wrap ${!(["SL"].includes(eachData["ORDER TYPE"])) && ' div-disabled'}`} onClick={handleSLLimitIncDec.bind(this, "subSLLimit", eachData.id)}></div>
                                                                                <BzInputText size='sm' type='number' className='font-regular text-center' onFocus={() => handleLimitFocus(eachData.id)} value={eachData["SL LIMIT"]} onChange={(e) => handleSLLimit(e, eachData.id)} onBlur={handleLimitBlur.bind(this, eachData.id)} disabled={!(["SL"].includes(eachData["ORDER TYPE"]))} />
                                                                                <div className={`icon-12 icon-order-increase input-number-right-wrap ${!(["SL"].includes(eachData["ORDER TYPE"])) && 'div-disabled'}`} onClick={handleSLLimitIncDec.bind(this, "addSLLimit", eachData.id)}></div>
                                                                            </div>
                                                                            <div className='d-flex align-items-center mt-2'>
                                                                                <BzToolTip placement='left' TooltipMsg='You can place your order within this price range.It is rectified by the exchanges or the nature of trading you are placing.'>
                                                                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                                                </BzToolTip>
                                                                                <div className='font-regular font-size2 color-subtext ms-1'>Range: <span className={`font-regular font-size2 ${objRangeColor.limit}`}>{eachData["Range"]}</span></div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : null}
                                                                <Row className='mb-3'>
                                                                    <Col md={6}>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Validity</div>
                                                                        <div className='Bzmodalselect-dropdown'>
                                                                            <BzDropdown>
                                                                                <Dropdown.Toggle className='btn-default'>{eachData["VALIDITY"]}</Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {eachData["EXCHANGE"] == 'NSE' ?
                                                                                        objDropdownOptions.validityNSE?.length > 0 && objDropdownOptions.validityNSE?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={() => handleDropdown({ target: { value: eachOption, name: 'validity' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                        )) :
                                                                                        objDropdownOptions.validityBSE?.length > 0 && objDropdownOptions.validityBSE?.map((eachOption, i) => (
                                                                                            <Dropdown.Item key={i} onClick={() => handleDropdown({ target: { value: eachOption, name: 'validity' } }, eachData.id)}>{eachOption}</Dropdown.Item>
                                                                                        ))
                                                                                    }
                                                                                </Dropdown.Menu>
                                                                            </BzDropdown>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6} className='d-flex align-items-center mt-4'>
                                                                        <input type='checkbox' className='form-check-input me-2' checked={eachData["AMO"]} onChange={(e) => handleAMO(e, eachData.id)} />
                                                                        <div className='font-medium font-size1 color-text text-uppercase'>AMO</div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            : null
                                                    }
                                                </div ></>;
                                        })}
                                    {
                                        bIsShowSearchScrip == false ?

                                            <Row className='g-0 mb-3'>
                                                <Col>
                                                    <BzButton className="btn btn-outline btn-sm d-flex align-items-center" onClick={handleAddScrips}>
                                                        <div className="icon-16 icon-add-circle-fill icon-primary me-2"></div>
                                                        <span className='font-medium font-size1'>Add Scrip</span>
                                                    </BzButton>
                                                </Col>
                                                {/* ManasaB : 18-10-2024 : Commented Temporarily - Start */}
                                                {/* <Col className='d-flex flex-column align-items-end'>
                                            <BzButton className='btn btn-outline btn-sm d-flex align-items-center'>
                                                <span>Upload Excel</span>
                                                <div className='icon-16 icon-upload icon-primary ms-2'></div>
                                            </BzButton>
                                            <a href='#' className='font-medium font-size1 color-primary text-center mt-2'>Download Sample File</a>
                                        </Col> */}
                                                {/* ManasaB : 18-10-2024 : Commented Temporarily - End */}
                                            </Row> :
                                            <Row className='g-0 mb-3 justify-content-center'>
                                                <Col md={12} className='d-flex align-items-center'>
                                                    <div className='position-relative w-100'>
                                                        <div className="icon-14 icon-search icon-grey search-icon-position"></div>
                                                        <BzInputText size='sm' type='search' className='p-l-30 font-regular' placeholder='Search scrips to add...' value={strSearchInputText} onChange={(e) => onChangeTabSearch(e)}></BzInputText>
                                                    </div>
                                                    <div className="icon-20 icon-close-fill icon-primary ms-1 flex-shrink-0" onClick={() => setBIsShowSearchScrip(false)}></div>
                                                </Col>
                                                <div className="oe-vertical-search-wrapper">
                                                    <div className="oe-search-content">
                                                        {orderBookSearchModal ?
                                                            <div className='oe-search-wrap'>
                                                                <div className='oe-search-content'>
                                                                    <TabsScripsList isKeyboard={false} arrGlobalScripts={arrGlobalScripts} showDefault isActive setAddToggle={setAddToggle}
                                                                        strSearchInputText={strSearchInputText} orderBookSearchModal={orderBookSearchModal} setStrSearchInputText={setStrSearchInputText}
                                                                        scripDetails={isFlag ? globalScripDetails : arrSymbolData} isDefaultAllTab={true}
                                                                        setOrderBookSearchModal={setOrderBookSearchModal}
                                                                        onBuySellClick={onBuySellClick} checkBuyExisting={checkBuyExisting} checkSellExisting={checkSellExisting} />
                                                                </div>
                                                            </div>
                                                            : ""}
                                                    </div>
                                                </div>
                                            </Row>}
                                    {
                                        isShowMarketDepth &&
                                        <Row className='g-0 bdr-top px-2 py-3'>
                                            <Row className='g-0'>
                                                <Col md={12} className='d-flex justify-content-start align-items-center'>
                                                    <Button className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                                    <Button className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                                </Col>
                                            </Row>
                                            {marketDepthActiveTab === "MarketDepth" ?
                                                <>
                                                    <BzTabs className='nav nav-tabs horizontal-scroll-wrap my-2 d-flex flex-row'>
                                                        {
                                                            arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                                <BzTab key={i} className={`nav-link text-capitalize ${each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab ? 'active' : ''}`} tabKey={each[WATCHLIST_GRID_INDEX.SEGMENT_ID]} onClick={() => setMarketDepthTab(each[WATCHLIST_GRID_INDEX.SEGMENT_ID])}>
                                                                    {each[WATCHLIST_GRID_INDEX.EXCHANGE]}
                                                                </BzTab>
                                                            )
                                                        }
                                                    </BzTabs>
                                                    {
                                                        arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                            each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab && <MarketDepthGrid onValueClick={onValueClick} layoutType={LAYOUT_TYPE.VERTICAL} ref={[createRef(), createRef()]} key={i} scripData={each} />
                                                        )
                                                    }
                                                </>
                                                : marketDepthActiveTab === "supportResistance" ? <SupportResistance onValueClick={onValueClick} supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={LAYOUT_TYPE.VERTICAL} /> : null}
                                        </Row>
                                    }
                                </Container>
                            </div>
                        </>
                        // ManasaB:07-10-14 : UI changes taken from release branch -End
                        : null
                )
            }
        </>
    );
});

export default memo(Basket);